// source: common/common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.mw.common.Address', null, global);
goog.exportSymbol('proto.mw.common.AddressType', null, global);
goog.exportSymbol('proto.mw.common.Category', null, global);
goog.exportSymbol('proto.mw.common.Customer', null, global);
goog.exportSymbol('proto.mw.common.Image', null, global);
goog.exportSymbol('proto.mw.common.ImageType', null, global);
goog.exportSymbol('proto.mw.common.MainCategory', null, global);
goog.exportSymbol('proto.mw.common.MiniShop', null, global);
goog.exportSymbol('proto.mw.common.Order', null, global);
goog.exportSymbol('proto.mw.common.OrderForm', null, global);
goog.exportSymbol('proto.mw.common.OrderFormCategory', null, global);
goog.exportSymbol('proto.mw.common.OrderFormProduct', null, global);
goog.exportSymbol('proto.mw.common.OrderFormProductCell', null, global);
goog.exportSymbol('proto.mw.common.OrderFormProductDisplay', null, global);
goog.exportSymbol('proto.mw.common.OrderFormProductGroup', null, global);
goog.exportSymbol('proto.mw.common.OrderFormProductLine', null, global);
goog.exportSymbol('proto.mw.common.OrderFormProductRow', null, global);
goog.exportSymbol('proto.mw.common.OrderFormProductStatus', null, global);
goog.exportSymbol('proto.mw.common.OrderFormV2Category', null, global);
goog.exportSymbol('proto.mw.common.OrderFormV2CategoryGrouped', null, global);
goog.exportSymbol('proto.mw.common.OrderFormV2ProductGroup', null, global);
goog.exportSymbol('proto.mw.common.OrderFormV2ProductLine', null, global);
goog.exportSymbol('proto.mw.common.OrderFormV2Row', null, global);
goog.exportSymbol('proto.mw.common.OrderProduct', null, global);
goog.exportSymbol('proto.mw.common.OrderStatus', null, global);
goog.exportSymbol('proto.mw.common.OrderSummary', null, global);
goog.exportSymbol('proto.mw.common.OrderType', null, global);
goog.exportSymbol('proto.mw.common.PaymentType', null, global);
goog.exportSymbol('proto.mw.common.PreviewCustomerProfile', null, global);
goog.exportSymbol('proto.mw.common.PreviewStatistics', null, global);
goog.exportSymbol('proto.mw.common.Product', null, global);
goog.exportSymbol('proto.mw.common.ProductSkinProblemEffectiveness', null, global);
goog.exportSymbol('proto.mw.common.SkinProblem', null, global);
goog.exportSymbol('proto.mw.common.SpecialOffer', null, global);
goog.exportSymbol('proto.mw.common.SpecialOfferType', null, global);
goog.exportSymbol('proto.mw.common.Usage', null, global);
goog.exportSymbol('proto.mw.common.UsageSummary', null, global);
goog.exportSymbol('proto.mw.common.UsageType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.Category = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.Category, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.Category.displayName = 'proto.mw.common.Category';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.Customer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.Customer.repeatedFields_, null);
};
goog.inherits(proto.mw.common.Customer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.Customer.displayName = 'proto.mw.common.Customer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.Address.displayName = 'proto.mw.common.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.Product.repeatedFields_, null);
};
goog.inherits(proto.mw.common.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.Product.displayName = 'proto.mw.common.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.Order = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.Order, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.Order.displayName = 'proto.mw.common.Order';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderSummary.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderSummary.displayName = 'proto.mw.common.OrderSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.OrderProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderProduct.displayName = 'proto.mw.common.OrderProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.SpecialOffer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.SpecialOffer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.SpecialOffer.displayName = 'proto.mw.common.SpecialOffer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.Image = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.Image, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.Image.displayName = 'proto.mw.common.Image';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.MiniShop = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.MiniShop.repeatedFields_, null);
};
goog.inherits(proto.mw.common.MiniShop, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.MiniShop.displayName = 'proto.mw.common.MiniShop';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.Usage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.Usage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.Usage.displayName = 'proto.mw.common.Usage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.UsageSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.UsageSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.UsageSummary.displayName = 'proto.mw.common.UsageSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderForm.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderForm.displayName = 'proto.mw.common.OrderForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormCategory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormCategory.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormCategory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormCategory.displayName = 'proto.mw.common.OrderFormCategory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormProductGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormProductGroup.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormProductGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormProductGroup.displayName = 'proto.mw.common.OrderFormProductGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormProductLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormProductLine.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormProductLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormProductLine.displayName = 'proto.mw.common.OrderFormProductLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormProductRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormProductRow.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormProductRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormProductRow.displayName = 'proto.mw.common.OrderFormProductRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormProductCell = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.OrderFormProductCell, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormProductCell.displayName = 'proto.mw.common.OrderFormProductCell';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.OrderFormProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormProduct.displayName = 'proto.mw.common.OrderFormProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormProductDisplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormProductDisplay.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormProductDisplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormProductDisplay.displayName = 'proto.mw.common.OrderFormProductDisplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.PreviewCustomerProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.PreviewCustomerProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.PreviewCustomerProfile.displayName = 'proto.mw.common.PreviewCustomerProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.PreviewStatistics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.PreviewStatistics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.PreviewStatistics.displayName = 'proto.mw.common.PreviewStatistics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormV2Category = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormV2Category.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormV2Category, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormV2Category.displayName = 'proto.mw.common.OrderFormV2Category';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormV2ProductLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormV2ProductLine.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormV2ProductLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormV2ProductLine.displayName = 'proto.mw.common.OrderFormV2ProductLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormV2CategoryGrouped = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormV2CategoryGrouped.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormV2CategoryGrouped, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormV2CategoryGrouped.displayName = 'proto.mw.common.OrderFormV2CategoryGrouped';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormV2ProductGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormV2ProductGroup.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormV2ProductGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormV2ProductGroup.displayName = 'proto.mw.common.OrderFormV2ProductGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.OrderFormV2Row = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.common.OrderFormV2Row.repeatedFields_, null);
};
goog.inherits(proto.mw.common.OrderFormV2Row, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.OrderFormV2Row.displayName = 'proto.mw.common.OrderFormV2Row';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.SkinProblem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.SkinProblem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.SkinProblem.displayName = 'proto.mw.common.SkinProblem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.common.ProductSkinProblemEffectiveness = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.common.ProductSkinProblemEffectiveness, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.common.ProductSkinProblemEffectiveness.displayName = 'proto.mw.common.ProductSkinProblemEffectiveness';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.Category.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.Category.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.Category} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Category.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
level: jspb.Message.getFieldWithDefault(msg, 2, 0),
identifier: jspb.Message.getFieldWithDefault(msg, 3, ""),
title: jspb.Message.getFieldWithDefault(msg, 4, ""),
orderFormTitle: jspb.Message.getFieldWithDefault(msg, 5, ""),
orderFormOrder: jspb.Message.getFieldWithDefault(msg, 6, 0),
productCategoryId: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.Category}
 */
proto.mw.common.Category.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.Category;
  return proto.mw.common.Category.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.Category} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.Category}
 */
proto.mw.common.Category.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderFormTitle(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderFormOrder(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.Category.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.Category.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.Category} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Category.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrderFormTitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOrderFormOrder();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getProductCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.mw.common.Category.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Category} returns this
 */
proto.mw.common.Category.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 level = 2;
 * @return {number}
 */
proto.mw.common.Category.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Category} returns this
 */
proto.mw.common.Category.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string identifier = 3;
 * @return {string}
 */
proto.mw.common.Category.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Category} returns this
 */
proto.mw.common.Category.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.mw.common.Category.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Category} returns this
 */
proto.mw.common.Category.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string order_form_title = 5;
 * @return {string}
 */
proto.mw.common.Category.prototype.getOrderFormTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Category} returns this
 */
proto.mw.common.Category.prototype.setOrderFormTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 order_form_order = 6;
 * @return {number}
 */
proto.mw.common.Category.prototype.getOrderFormOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Category} returns this
 */
proto.mw.common.Category.prototype.setOrderFormOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 product_category_id = 7;
 * @return {number}
 */
proto.mw.common.Category.prototype.getProductCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Category} returns this
 */
proto.mw.common.Category.prototype.setProductCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.Customer.repeatedFields_ = [31];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.Customer.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.Customer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Customer.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
sapId: jspb.Message.getFieldWithDefault(msg, 5, 0),
legacyId: jspb.Message.getFieldWithDefault(msg, 6, 0),
email: jspb.Message.getFieldWithDefault(msg, 7, ""),
password: jspb.Message.getFieldWithDefault(msg, 8, ""),
name1: jspb.Message.getFieldWithDefault(msg, 9, ""),
name2: jspb.Message.getFieldWithDefault(msg, 10, ""),
street: jspb.Message.getFieldWithDefault(msg, 11, ""),
zip: jspb.Message.getFieldWithDefault(msg, 12, ""),
city: jspb.Message.getFieldWithDefault(msg, 13, ""),
country: jspb.Message.getFieldWithDefault(msg, 14, ""),
phone: jspb.Message.getFieldWithDefault(msg, 15, ""),
mobile: jspb.Message.getFieldWithDefault(msg, 16, ""),
fax: jspb.Message.getFieldWithDefault(msg, 17, ""),
website: jspb.Message.getFieldWithDefault(msg, 18, ""),
classification: jspb.Message.getFieldWithDefault(msg, 19, ""),
careProducts: jspb.Message.getFieldWithDefault(msg, 20, 0),
decoProducts: jspb.Message.getFieldWithDefault(msg, 21, 0),
hairdresserProducts: jspb.Message.getFieldWithDefault(msg, 22, 0),
detoxProducts: jspb.Message.getFieldWithDefault(msg, 23, 0),
blocked: jspb.Message.getFieldWithDefault(msg, 24, 0),
internalNote: jspb.Message.getFieldWithDefault(msg, 25, ""),
activationCode: jspb.Message.getFieldWithDefault(msg, 26, ""),
firstLogin: jspb.Message.getFieldWithDefault(msg, 27, ""),
lastLogin: jspb.Message.getFieldWithDefault(msg, 28, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 29, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 30, ""),
specialOffersList: jspb.Message.toObjectList(msg.getSpecialOffersList(),
    proto.mw.common.SpecialOffer.toObject, includeInstance),
deliveryName1: jspb.Message.getFieldWithDefault(msg, 32, ""),
deliveryName2: jspb.Message.getFieldWithDefault(msg, 33, ""),
deliveryStreet: jspb.Message.getFieldWithDefault(msg, 34, ""),
deliveryZip: jspb.Message.getFieldWithDefault(msg, 35, ""),
deliveryCity: jspb.Message.getFieldWithDefault(msg, 36, ""),
deliveryCountry: jspb.Message.getFieldWithDefault(msg, 37, ""),
deliveryPhone: jspb.Message.getFieldWithDefault(msg, 38, ""),
deliveryAddress: jspb.Message.getBooleanFieldWithDefault(msg, 39, false),
studentProducts: jspb.Message.getFieldWithDefault(msg, 40, 0),
studentVerified: jspb.Message.getFieldWithDefault(msg, 41, 0),
studentVerificationStart: jspb.Message.getFieldWithDefault(msg, 42, ""),
studentVerificationEnd: jspb.Message.getFieldWithDefault(msg, 43, ""),
studentPaypalOrderCount: jspb.Message.getFieldWithDefault(msg, 44, 0),
rejectionReason: jspb.Message.getFieldWithDefault(msg, 45, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.Customer}
 */
proto.mw.common.Customer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.Customer;
  return proto.mw.common.Customer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.Customer}
 */
proto.mw.common.Customer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSapId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLegacyId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setName1(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setName2(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreet(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setFax(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsite(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setClassification(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCareProducts(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDecoProducts(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHairdresserProducts(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDetoxProducts(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlocked(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setInternalNote(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivationCode(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstLogin(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastLogin(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 31:
      var value = new proto.mw.common.SpecialOffer;
      reader.readMessage(value,proto.mw.common.SpecialOffer.deserializeBinaryFromReader);
      msg.addSpecialOffers(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryName1(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryName2(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryStreet(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryZip(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryCity(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryCountry(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryPhone(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeliveryAddress(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStudentProducts(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStudentVerified(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudentVerificationStart(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudentVerificationEnd(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStudentPaypalOrderCount(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setRejectionReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.Customer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.Customer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Customer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSapId();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getLegacyId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getName1();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getName2();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getFax();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getWebsite();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getClassification();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getCareProducts();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getDecoProducts();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getHairdresserProducts();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getDetoxProducts();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getBlocked();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getInternalNote();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getActivationCode();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getFirstLogin();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getLastLogin();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getSpecialOffersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      31,
      f,
      proto.mw.common.SpecialOffer.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryName1();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getDeliveryName2();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getDeliveryStreet();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getDeliveryZip();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getDeliveryCity();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getDeliveryCountry();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getDeliveryPhone();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getDeliveryAddress();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
  f = message.getStudentProducts();
  if (f !== 0) {
    writer.writeInt32(
      40,
      f
    );
  }
  f = message.getStudentVerified();
  if (f !== 0) {
    writer.writeInt32(
      41,
      f
    );
  }
  f = message.getStudentVerificationStart();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getStudentVerificationEnd();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getStudentPaypalOrderCount();
  if (f !== 0) {
    writer.writeInt32(
      44,
      f
    );
  }
  f = message.getRejectionReason();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sap_id = 5;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getSapId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setSapId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 legacy_id = 6;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setLegacyId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string email = 7;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string password = 8;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string name1 = 9;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getName1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setName1 = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string name2 = 10;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getName2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setName2 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string street = 11;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string zip = 12;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string city = 13;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string country = 14;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string phone = 15;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string mobile = 16;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string fax = 17;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getFax = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setFax = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string website = 18;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getWebsite = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setWebsite = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string classification = 19;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getClassification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setClassification = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional int32 care_products = 20;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getCareProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setCareProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int32 deco_products = 21;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getDecoProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDecoProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int32 hairdresser_products = 22;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getHairdresserProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setHairdresserProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int32 detox_products = 23;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getDetoxProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDetoxProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int32 blocked = 24;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getBlocked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setBlocked = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional string internal_note = 25;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getInternalNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setInternalNote = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string activation_code = 26;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getActivationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setActivationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string first_login = 27;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getFirstLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setFirstLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string last_login = 28;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getLastLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setLastLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string created_at = 29;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string updated_at = 30;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * repeated SpecialOffer special_offers = 31;
 * @return {!Array<!proto.mw.common.SpecialOffer>}
 */
proto.mw.common.Customer.prototype.getSpecialOffersList = function() {
  return /** @type{!Array<!proto.mw.common.SpecialOffer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.SpecialOffer, 31));
};


/**
 * @param {!Array<!proto.mw.common.SpecialOffer>} value
 * @return {!proto.mw.common.Customer} returns this
*/
proto.mw.common.Customer.prototype.setSpecialOffersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 31, value);
};


/**
 * @param {!proto.mw.common.SpecialOffer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.SpecialOffer}
 */
proto.mw.common.Customer.prototype.addSpecialOffers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 31, opt_value, proto.mw.common.SpecialOffer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.clearSpecialOffersList = function() {
  return this.setSpecialOffersList([]);
};


/**
 * optional string delivery_name1 = 32;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getDeliveryName1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDeliveryName1 = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string delivery_name2 = 33;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getDeliveryName2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDeliveryName2 = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string delivery_street = 34;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getDeliveryStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDeliveryStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string delivery_zip = 35;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getDeliveryZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDeliveryZip = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string delivery_city = 36;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getDeliveryCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDeliveryCity = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string delivery_country = 37;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getDeliveryCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDeliveryCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string delivery_phone = 38;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getDeliveryPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDeliveryPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional bool delivery_address = 39;
 * @return {boolean}
 */
proto.mw.common.Customer.prototype.getDeliveryAddress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setDeliveryAddress = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


/**
 * optional int32 student_products = 40;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getStudentProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setStudentProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional int32 student_verified = 41;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getStudentVerified = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setStudentVerified = function(value) {
  return jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional string student_verification_start = 42;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getStudentVerificationStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setStudentVerificationStart = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional string student_verification_end = 43;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getStudentVerificationEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setStudentVerificationEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional int32 student_paypal_order_count = 44;
 * @return {number}
 */
proto.mw.common.Customer.prototype.getStudentPaypalOrderCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setStudentPaypalOrderCount = function(value) {
  return jspb.Message.setProto3IntField(this, 44, value);
};


/**
 * optional string rejection_reason = 45;
 * @return {string}
 */
proto.mw.common.Customer.prototype.getRejectionReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Customer} returns this
 */
proto.mw.common.Customer.prototype.setRejectionReason = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
addressType: jspb.Message.getFieldWithDefault(msg, 1, 0),
name1: jspb.Message.getFieldWithDefault(msg, 2, ""),
name2: jspb.Message.getFieldWithDefault(msg, 3, ""),
street: jspb.Message.getFieldWithDefault(msg, 4, ""),
zip: jspb.Message.getFieldWithDefault(msg, 5, ""),
city: jspb.Message.getFieldWithDefault(msg, 6, ""),
country: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.Address}
 */
proto.mw.common.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.Address;
  return proto.mw.common.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.Address}
 */
proto.mw.common.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.mw.common.AddressType} */ (reader.readEnum());
      msg.setAddressType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName1(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName2(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreet(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName1();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName2();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional AddressType address_type = 1;
 * @return {!proto.mw.common.AddressType}
 */
proto.mw.common.Address.prototype.getAddressType = function() {
  return /** @type {!proto.mw.common.AddressType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.mw.common.AddressType} value
 * @return {!proto.mw.common.Address} returns this
 */
proto.mw.common.Address.prototype.setAddressType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name1 = 2;
 * @return {string}
 */
proto.mw.common.Address.prototype.getName1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Address} returns this
 */
proto.mw.common.Address.prototype.setName1 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name2 = 3;
 * @return {string}
 */
proto.mw.common.Address.prototype.getName2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Address} returns this
 */
proto.mw.common.Address.prototype.setName2 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string street = 4;
 * @return {string}
 */
proto.mw.common.Address.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Address} returns this
 */
proto.mw.common.Address.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string zip = 5;
 * @return {string}
 */
proto.mw.common.Address.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Address} returns this
 */
proto.mw.common.Address.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string city = 6;
 * @return {string}
 */
proto.mw.common.Address.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Address} returns this
 */
proto.mw.common.Address.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string country = 7;
 * @return {string}
 */
proto.mw.common.Address.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Address} returns this
 */
proto.mw.common.Address.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.Product.repeatedFields_ = [34];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
sapId: jspb.Message.getFieldWithDefault(msg, 2, 0),
productCategoryId: jspb.Message.getFieldWithDefault(msg, 3, 0),
ean: jspb.Message.getFieldWithDefault(msg, 4, ""),
modelNumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
nameDe: jspb.Message.getFieldWithDefault(msg, 6, ""),
nameEn: jspb.Message.getFieldWithDefault(msg, 7, ""),
blocked: jspb.Message.getFieldWithDefault(msg, 8, 0),
priceB2b: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
priceB2c: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
careProduct: jspb.Message.getFieldWithDefault(msg, 11, 0),
decoProduct: jspb.Message.getFieldWithDefault(msg, 12, 0),
hairdresserProduct: jspb.Message.getFieldWithDefault(msg, 13, 0),
detoxProduct: jspb.Message.getFieldWithDefault(msg, 14, 0),
stock: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
ingredients: jspb.Message.getFieldWithDefault(msg, 16, ""),
quantityPerPack: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
quantityUnitKey: jspb.Message.getFieldWithDefault(msg, 18, ""),
quantityUnitName: jspb.Message.getFieldWithDefault(msg, 19, ""),
productLineKey: jspb.Message.getFieldWithDefault(msg, 20, ""),
productLineName: jspb.Message.getFieldWithDefault(msg, 21, ""),
variantName: jspb.Message.getFieldWithDefault(msg, 22, ""),
variantNumber: jspb.Message.getFieldWithDefault(msg, 23, ""),
internalNote: jspb.Message.getFieldWithDefault(msg, 24, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 25, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 26, ""),
deletedAt: jspb.Message.getFieldWithDefault(msg, 27, ""),
productCategoryName: jspb.Message.getFieldWithDefault(msg, 28, ""),
productCategoryLevel: jspb.Message.getFieldWithDefault(msg, 29, 0),
minimalOrderQuantity: jspb.Message.getFieldWithDefault(msg, 30, 0),
googleId: jspb.Message.getFieldWithDefault(msg, 31, ""),
productGroup: jspb.Message.getFieldWithDefault(msg, 32, ""),
description: jspb.Message.getFieldWithDefault(msg, 33, ""),
specialOffersList: jspb.Message.toObjectList(msg.getSpecialOffersList(),
    proto.mw.common.SpecialOffer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.Product}
 */
proto.mw.common.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.Product;
  return proto.mw.common.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.Product}
 */
proto.mw.common.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSapId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProductCategoryId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEan(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNameDe(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNameEn(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlocked(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPriceB2b(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPriceB2c(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCareProduct(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDecoProduct(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHairdresserProduct(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDetoxProduct(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStock(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setIngredients(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setQuantityPerPack(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuantityUnitKey(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuantityUnitName(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductLineKey(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductLineName(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setVariantName(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setVariantNumber(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setInternalNote(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeletedAt(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCategoryName(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductCategoryLevel(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinimalOrderQuantity(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setGoogleId(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductGroup(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 34:
      var value = new proto.mw.common.SpecialOffer;
      reader.readMessage(value,proto.mw.common.SpecialOffer.deserializeBinaryFromReader);
      msg.addSpecialOffers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSapId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getProductCategoryId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getEan();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getModelNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNameDe();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNameEn();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBlocked();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getPriceB2b();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getPriceB2c();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getCareProduct();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getDecoProduct();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getHairdresserProduct();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getDetoxProduct();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getStock();
  if (f !== 0.0) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = message.getIngredients();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getQuantityPerPack();
  if (f !== 0.0) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = message.getQuantityUnitKey();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getQuantityUnitName();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getProductLineKey();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getProductLineName();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getVariantName();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getVariantNumber();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getInternalNote();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getDeletedAt();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getProductCategoryName();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getProductCategoryLevel();
  if (f !== 0) {
    writer.writeInt32(
      29,
      f
    );
  }
  f = message.getMinimalOrderQuantity();
  if (f !== 0) {
    writer.writeInt32(
      30,
      f
    );
  }
  f = message.getGoogleId();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getProductGroup();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getSpecialOffersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      34,
      f,
      proto.mw.common.SpecialOffer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.mw.common.Product.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sap_id = 2;
 * @return {number}
 */
proto.mw.common.Product.prototype.getSapId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setSapId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 product_category_id = 3;
 * @return {number}
 */
proto.mw.common.Product.prototype.getProductCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setProductCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string ean = 4;
 * @return {string}
 */
proto.mw.common.Product.prototype.getEan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setEan = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string model_number = 5;
 * @return {string}
 */
proto.mw.common.Product.prototype.getModelNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setModelNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name_de = 6;
 * @return {string}
 */
proto.mw.common.Product.prototype.getNameDe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setNameDe = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string name_en = 7;
 * @return {string}
 */
proto.mw.common.Product.prototype.getNameEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setNameEn = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 blocked = 8;
 * @return {number}
 */
proto.mw.common.Product.prototype.getBlocked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setBlocked = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional float price_b2b = 9;
 * @return {number}
 */
proto.mw.common.Product.prototype.getPriceB2b = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setPriceB2b = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional float price_b2c = 10;
 * @return {number}
 */
proto.mw.common.Product.prototype.getPriceB2c = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setPriceB2c = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional int32 care_product = 11;
 * @return {number}
 */
proto.mw.common.Product.prototype.getCareProduct = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setCareProduct = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 deco_product = 12;
 * @return {number}
 */
proto.mw.common.Product.prototype.getDecoProduct = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setDecoProduct = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 hairdresser_product = 13;
 * @return {number}
 */
proto.mw.common.Product.prototype.getHairdresserProduct = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setHairdresserProduct = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 detox_product = 14;
 * @return {number}
 */
proto.mw.common.Product.prototype.getDetoxProduct = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setDetoxProduct = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional float stock = 15;
 * @return {number}
 */
proto.mw.common.Product.prototype.getStock = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setStock = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional string ingredients = 16;
 * @return {string}
 */
proto.mw.common.Product.prototype.getIngredients = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setIngredients = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional float quantity_per_pack = 17;
 * @return {number}
 */
proto.mw.common.Product.prototype.getQuantityPerPack = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setQuantityPerPack = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional string quantity_unit_key = 18;
 * @return {string}
 */
proto.mw.common.Product.prototype.getQuantityUnitKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setQuantityUnitKey = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string quantity_unit_name = 19;
 * @return {string}
 */
proto.mw.common.Product.prototype.getQuantityUnitName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setQuantityUnitName = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string product_line_key = 20;
 * @return {string}
 */
proto.mw.common.Product.prototype.getProductLineKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setProductLineKey = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string product_line_name = 21;
 * @return {string}
 */
proto.mw.common.Product.prototype.getProductLineName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setProductLineName = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string variant_name = 22;
 * @return {string}
 */
proto.mw.common.Product.prototype.getVariantName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setVariantName = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string variant_number = 23;
 * @return {string}
 */
proto.mw.common.Product.prototype.getVariantNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setVariantNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string internal_note = 24;
 * @return {string}
 */
proto.mw.common.Product.prototype.getInternalNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setInternalNote = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string created_at = 25;
 * @return {string}
 */
proto.mw.common.Product.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string updated_at = 26;
 * @return {string}
 */
proto.mw.common.Product.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string deleted_at = 27;
 * @return {string}
 */
proto.mw.common.Product.prototype.getDeletedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setDeletedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string product_category_name = 28;
 * @return {string}
 */
proto.mw.common.Product.prototype.getProductCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setProductCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional int32 product_category_level = 29;
 * @return {number}
 */
proto.mw.common.Product.prototype.getProductCategoryLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setProductCategoryLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional int32 minimal_order_quantity = 30;
 * @return {number}
 */
proto.mw.common.Product.prototype.getMinimalOrderQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setMinimalOrderQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional string google_id = 31;
 * @return {string}
 */
proto.mw.common.Product.prototype.getGoogleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setGoogleId = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string product_group = 32;
 * @return {string}
 */
proto.mw.common.Product.prototype.getProductGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setProductGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string description = 33;
 * @return {string}
 */
proto.mw.common.Product.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * repeated SpecialOffer special_offers = 34;
 * @return {!Array<!proto.mw.common.SpecialOffer>}
 */
proto.mw.common.Product.prototype.getSpecialOffersList = function() {
  return /** @type{!Array<!proto.mw.common.SpecialOffer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.SpecialOffer, 34));
};


/**
 * @param {!Array<!proto.mw.common.SpecialOffer>} value
 * @return {!proto.mw.common.Product} returns this
*/
proto.mw.common.Product.prototype.setSpecialOffersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 34, value);
};


/**
 * @param {!proto.mw.common.SpecialOffer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.SpecialOffer}
 */
proto.mw.common.Product.prototype.addSpecialOffers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 34, opt_value, proto.mw.common.SpecialOffer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.Product} returns this
 */
proto.mw.common.Product.prototype.clearSpecialOffersList = function() {
  return this.setSpecialOffersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.Order.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.Order.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.Order} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Order.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
customer: (f = msg.getCustomer()) && proto.mw.common.Customer.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
sapId: jspb.Message.getFieldWithDefault(msg, 4, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 5, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 6, ""),
processedAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
shippedAt: jspb.Message.getFieldWithDefault(msg, 8, ""),
orderSummary: (f = msg.getOrderSummary()) && proto.mw.common.OrderSummary.toObject(includeInstance, f),
hasInvoice: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
note: jspb.Message.getFieldWithDefault(msg, 11, ""),
email: jspb.Message.getFieldWithDefault(msg, 12, ""),
name1: jspb.Message.getFieldWithDefault(msg, 13, ""),
name2: jspb.Message.getFieldWithDefault(msg, 14, ""),
street: jspb.Message.getFieldWithDefault(msg, 15, ""),
zip: jspb.Message.getFieldWithDefault(msg, 16, ""),
city: jspb.Message.getFieldWithDefault(msg, 17, ""),
country: jspb.Message.getFieldWithDefault(msg, 18, ""),
deliveryAddress: (f = msg.getDeliveryAddress()) && proto.mw.common.Address.toObject(includeInstance, f),
orderType: jspb.Message.getFieldWithDefault(msg, 20, 0),
paymentType: jspb.Message.getFieldWithDefault(msg, 21, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.Order}
 */
proto.mw.common.Order.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.Order;
  return proto.mw.common.Order.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.Order}
 */
proto.mw.common.Order.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.mw.common.Customer;
      reader.readMessage(value,proto.mw.common.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 3:
      var value = /** @type {!proto.mw.common.OrderStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSapId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProcessedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippedAt(value);
      break;
    case 9:
      var value = new proto.mw.common.OrderSummary;
      reader.readMessage(value,proto.mw.common.OrderSummary.deserializeBinaryFromReader);
      msg.setOrderSummary(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasInvoice(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setName1(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setName2(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreet(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 19:
      var value = new proto.mw.common.Address;
      reader.readMessage(value,proto.mw.common.Address.deserializeBinaryFromReader);
      msg.setDeliveryAddress(value);
      break;
    case 20:
      var value = /** @type {!proto.mw.common.OrderType} */ (reader.readEnum());
      msg.setOrderType(value);
      break;
    case 21:
      var value = /** @type {!proto.mw.common.PaymentType} */ (reader.readEnum());
      msg.setPaymentType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.Order.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.Order.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Order.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.mw.common.Customer.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSapId();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProcessedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getShippedAt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOrderSummary();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.mw.common.OrderSummary.serializeBinaryToWriter
    );
  }
  f = message.getHasInvoice();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getName1();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getName2();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getDeliveryAddress();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.mw.common.Address.serializeBinaryToWriter
    );
  }
  f = message.getOrderType();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getPaymentType();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.mw.common.Order.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Customer customer = 2;
 * @return {?proto.mw.common.Customer}
 */
proto.mw.common.Order.prototype.getCustomer = function() {
  return /** @type{?proto.mw.common.Customer} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Customer, 2));
};


/**
 * @param {?proto.mw.common.Customer|undefined} value
 * @return {!proto.mw.common.Order} returns this
*/
proto.mw.common.Order.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.Order.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OrderStatus status = 3;
 * @return {!proto.mw.common.OrderStatus}
 */
proto.mw.common.Order.prototype.getStatus = function() {
  return /** @type {!proto.mw.common.OrderStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.mw.common.OrderStatus} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint64 sap_id = 4;
 * @return {number}
 */
proto.mw.common.Order.prototype.getSapId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setSapId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string created_at = 5;
 * @return {string}
 */
proto.mw.common.Order.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string updated_at = 6;
 * @return {string}
 */
proto.mw.common.Order.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string processed_at = 7;
 * @return {string}
 */
proto.mw.common.Order.prototype.getProcessedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setProcessedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string shipped_at = 8;
 * @return {string}
 */
proto.mw.common.Order.prototype.getShippedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setShippedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional OrderSummary order_summary = 9;
 * @return {?proto.mw.common.OrderSummary}
 */
proto.mw.common.Order.prototype.getOrderSummary = function() {
  return /** @type{?proto.mw.common.OrderSummary} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderSummary, 9));
};


/**
 * @param {?proto.mw.common.OrderSummary|undefined} value
 * @return {!proto.mw.common.Order} returns this
*/
proto.mw.common.Order.prototype.setOrderSummary = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.clearOrderSummary = function() {
  return this.setOrderSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.Order.prototype.hasOrderSummary = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool has_invoice = 10;
 * @return {boolean}
 */
proto.mw.common.Order.prototype.getHasInvoice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setHasInvoice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string note = 11;
 * @return {string}
 */
proto.mw.common.Order.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string email = 12;
 * @return {string}
 */
proto.mw.common.Order.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string name1 = 13;
 * @return {string}
 */
proto.mw.common.Order.prototype.getName1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setName1 = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string name2 = 14;
 * @return {string}
 */
proto.mw.common.Order.prototype.getName2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setName2 = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string street = 15;
 * @return {string}
 */
proto.mw.common.Order.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string zip = 16;
 * @return {string}
 */
proto.mw.common.Order.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string city = 17;
 * @return {string}
 */
proto.mw.common.Order.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string country = 18;
 * @return {string}
 */
proto.mw.common.Order.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional Address delivery_address = 19;
 * @return {?proto.mw.common.Address}
 */
proto.mw.common.Order.prototype.getDeliveryAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Address, 19));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.common.Order} returns this
*/
proto.mw.common.Order.prototype.setDeliveryAddress = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.clearDeliveryAddress = function() {
  return this.setDeliveryAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.Order.prototype.hasDeliveryAddress = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional OrderType order_type = 20;
 * @return {!proto.mw.common.OrderType}
 */
proto.mw.common.Order.prototype.getOrderType = function() {
  return /** @type {!proto.mw.common.OrderType} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.mw.common.OrderType} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setOrderType = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional PaymentType payment_type = 21;
 * @return {!proto.mw.common.PaymentType}
 */
proto.mw.common.Order.prototype.getPaymentType = function() {
  return /** @type {!proto.mw.common.PaymentType} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.mw.common.PaymentType} value
 * @return {!proto.mw.common.Order} returns this
 */
proto.mw.common.Order.prototype.setPaymentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderSummary.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
orderProductsList: jspb.Message.toObjectList(msg.getOrderProductsList(),
    proto.mw.common.OrderProduct.toObject, includeInstance),
totalPriceB2b: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalPriceB2c: jspb.Message.getFieldWithDefault(msg, 3, ""),
totalQuantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
shippingCosts: jspb.Message.getFieldWithDefault(msg, 5, ""),
vat: jspb.Message.getFieldWithDefault(msg, 6, ""),
minimumQuantitySurcharge: jspb.Message.getFieldWithDefault(msg, 7, ""),
onlineDiscount: jspb.Message.getFieldWithDefault(msg, 8, ""),
totalPrice: jspb.Message.getFieldWithDefault(msg, 9, ""),
vatPercentage: jspb.Message.getFieldWithDefault(msg, 10, ""),
containsSpecialOffer: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderSummary}
 */
proto.mw.common.OrderSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderSummary;
  return proto.mw.common.OrderSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderSummary}
 */
proto.mw.common.OrderSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.common.OrderProduct;
      reader.readMessage(value,proto.mw.common.OrderProduct.deserializeBinaryFromReader);
      msg.addOrderProducts(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalPriceB2b(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalPriceB2c(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalQuantity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingCosts(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setVat(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinimumQuantitySurcharge(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnlineDiscount(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalPrice(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setVatPercentage(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContainsSpecialOffer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.mw.common.OrderProduct.serializeBinaryToWriter
    );
  }
  f = message.getTotalPriceB2b();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalPriceB2c();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalQuantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getShippingCosts();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVat();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMinimumQuantitySurcharge();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOnlineDiscount();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTotalPrice();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getVatPercentage();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getContainsSpecialOffer();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * repeated OrderProduct order_products = 1;
 * @return {!Array<!proto.mw.common.OrderProduct>}
 */
proto.mw.common.OrderSummary.prototype.getOrderProductsList = function() {
  return /** @type{!Array<!proto.mw.common.OrderProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderProduct, 1));
};


/**
 * @param {!Array<!proto.mw.common.OrderProduct>} value
 * @return {!proto.mw.common.OrderSummary} returns this
*/
proto.mw.common.OrderSummary.prototype.setOrderProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.common.OrderProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderProduct}
 */
proto.mw.common.OrderSummary.prototype.addOrderProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.common.OrderProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.clearOrderProductsList = function() {
  return this.setOrderProductsList([]);
};


/**
 * optional string total_price_b2b = 2;
 * @return {string}
 */
proto.mw.common.OrderSummary.prototype.getTotalPriceB2b = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setTotalPriceB2b = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string total_price_b2c = 3;
 * @return {string}
 */
proto.mw.common.OrderSummary.prototype.getTotalPriceB2c = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setTotalPriceB2c = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 total_quantity = 4;
 * @return {number}
 */
proto.mw.common.OrderSummary.prototype.getTotalQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setTotalQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string shipping_costs = 5;
 * @return {string}
 */
proto.mw.common.OrderSummary.prototype.getShippingCosts = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setShippingCosts = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string vat = 6;
 * @return {string}
 */
proto.mw.common.OrderSummary.prototype.getVat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setVat = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string minimum_quantity_surcharge = 7;
 * @return {string}
 */
proto.mw.common.OrderSummary.prototype.getMinimumQuantitySurcharge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setMinimumQuantitySurcharge = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string online_discount = 8;
 * @return {string}
 */
proto.mw.common.OrderSummary.prototype.getOnlineDiscount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setOnlineDiscount = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string total_price = 9;
 * @return {string}
 */
proto.mw.common.OrderSummary.prototype.getTotalPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setTotalPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string vat_percentage = 10;
 * @return {string}
 */
proto.mw.common.OrderSummary.prototype.getVatPercentage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setVatPercentage = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool contains_special_offer = 11;
 * @return {boolean}
 */
proto.mw.common.OrderSummary.prototype.getContainsSpecialOffer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderSummary} returns this
 */
proto.mw.common.OrderSummary.prototype.setContainsSpecialOffer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
ean: jspb.Message.getFieldWithDefault(msg, 3, ""),
modelNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
nameDe: jspb.Message.getFieldWithDefault(msg, 5, ""),
nameEn: jspb.Message.getFieldWithDefault(msg, 6, ""),
priceB2b: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
priceB2c: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
quantityPerPack: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
quantityUnitKey: jspb.Message.getFieldWithDefault(msg, 10, ""),
quantityUnitName: jspb.Message.getFieldWithDefault(msg, 11, ""),
productLineKey: jspb.Message.getFieldWithDefault(msg, 12, ""),
productLineName: jspb.Message.getFieldWithDefault(msg, 13, ""),
variantName: jspb.Message.getFieldWithDefault(msg, 14, ""),
variantNumber: jspb.Message.getFieldWithDefault(msg, 15, ""),
productCategoryName: jspb.Message.getFieldWithDefault(msg, 16, ""),
productId: jspb.Message.getFieldWithDefault(msg, 17, ""),
minimalOrderQuantity: jspb.Message.getFieldWithDefault(msg, 18, 0),
googleId: jspb.Message.getFieldWithDefault(msg, 19, ""),
productGroup: jspb.Message.getFieldWithDefault(msg, 20, ""),
specialOffer: (f = msg.getSpecialOffer()) && proto.mw.common.SpecialOffer.toObject(includeInstance, f),
isAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
availabilityReason: jspb.Message.getFieldWithDefault(msg, 23, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderProduct}
 */
proto.mw.common.OrderProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderProduct;
  return proto.mw.common.OrderProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderProduct}
 */
proto.mw.common.OrderProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEan(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNameDe(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNameEn(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPriceB2b(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPriceB2c(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setQuantityPerPack(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuantityUnitKey(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuantityUnitName(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductLineKey(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductLineName(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setVariantName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setVariantNumber(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCategoryName(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMinimalOrderQuantity(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setGoogleId(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductGroup(value);
      break;
    case 21:
      var value = new proto.mw.common.SpecialOffer;
      reader.readMessage(value,proto.mw.common.SpecialOffer.deserializeBinaryFromReader);
      msg.setSpecialOffer(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAvailable(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvailabilityReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getEan();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModelNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNameDe();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNameEn();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPriceB2b();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getPriceB2c();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getQuantityPerPack();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getQuantityUnitKey();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getQuantityUnitName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getProductLineKey();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getProductLineName();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getVariantName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getVariantNumber();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getProductCategoryName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getMinimalOrderQuantity();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getGoogleId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getProductGroup();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getSpecialOffer();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.mw.common.SpecialOffer.serializeBinaryToWriter
    );
  }
  f = message.getIsAvailable();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getAvailabilityReason();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.mw.common.OrderProduct.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ean = 3;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getEan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setEan = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model_number = 4;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getModelNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setModelNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name_de = 5;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getNameDe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setNameDe = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name_en = 6;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getNameEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setNameEn = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional float price_b2b = 7;
 * @return {number}
 */
proto.mw.common.OrderProduct.prototype.getPriceB2b = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setPriceB2b = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional float price_b2c = 8;
 * @return {number}
 */
proto.mw.common.OrderProduct.prototype.getPriceB2c = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setPriceB2c = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional float quantity_per_pack = 9;
 * @return {number}
 */
proto.mw.common.OrderProduct.prototype.getQuantityPerPack = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setQuantityPerPack = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string quantity_unit_key = 10;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getQuantityUnitKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setQuantityUnitKey = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string quantity_unit_name = 11;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getQuantityUnitName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setQuantityUnitName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string product_line_key = 12;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getProductLineKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setProductLineKey = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string product_line_name = 13;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getProductLineName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setProductLineName = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string variant_name = 14;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getVariantName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setVariantName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string variant_number = 15;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getVariantNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setVariantNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string product_category_name = 16;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getProductCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setProductCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string product_id = 17;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional uint32 minimal_order_quantity = 18;
 * @return {number}
 */
proto.mw.common.OrderProduct.prototype.getMinimalOrderQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setMinimalOrderQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string google_id = 19;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getGoogleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setGoogleId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string product_group = 20;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getProductGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setProductGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional SpecialOffer special_offer = 21;
 * @return {?proto.mw.common.SpecialOffer}
 */
proto.mw.common.OrderProduct.prototype.getSpecialOffer = function() {
  return /** @type{?proto.mw.common.SpecialOffer} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.SpecialOffer, 21));
};


/**
 * @param {?proto.mw.common.SpecialOffer|undefined} value
 * @return {!proto.mw.common.OrderProduct} returns this
*/
proto.mw.common.OrderProduct.prototype.setSpecialOffer = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.clearSpecialOffer = function() {
  return this.setSpecialOffer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderProduct.prototype.hasSpecialOffer = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional bool is_available = 22;
 * @return {boolean}
 */
proto.mw.common.OrderProduct.prototype.getIsAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setIsAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional string availability_reason = 23;
 * @return {string}
 */
proto.mw.common.OrderProduct.prototype.getAvailabilityReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderProduct} returns this
 */
proto.mw.common.OrderProduct.prototype.setAvailabilityReason = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.SpecialOffer.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.SpecialOffer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.SpecialOffer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.SpecialOffer.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
product: (f = msg.getProduct()) && proto.mw.common.Product.toObject(includeInstance, f),
type: jspb.Message.getFieldWithDefault(msg, 3, 0),
validFrom: jspb.Message.getFieldWithDefault(msg, 4, ""),
validUntil: jspb.Message.getFieldWithDefault(msg, 5, ""),
removesShippingCosts: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
onlineDiscountApplicable: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
maxQuantityPerCustomer: jspb.Message.getFieldWithDefault(msg, 8, 0),
testMode: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
decoCustomerApplicable: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
careCustomerApplicable: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
description: jspb.Message.getFieldWithDefault(msg, 12, ""),
usages: jspb.Message.getFieldWithDefault(msg, 13, 0),
menuImage: (f = msg.getMenuImage()) && proto.mw.common.Image.toObject(includeInstance, f),
shopImage: (f = msg.getShopImage()) && proto.mw.common.Image.toObject(includeInstance, f),
createdAt: jspb.Message.getFieldWithDefault(msg, 16, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 17, ""),
infoBox: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.SpecialOffer}
 */
proto.mw.common.SpecialOffer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.SpecialOffer;
  return proto.mw.common.SpecialOffer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.SpecialOffer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.SpecialOffer}
 */
proto.mw.common.SpecialOffer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.mw.common.Product;
      reader.readMessage(value,proto.mw.common.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 3:
      var value = /** @type {!proto.mw.common.SpecialOfferType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidFrom(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidUntil(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemovesShippingCosts(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnlineDiscountApplicable(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxQuantityPerCustomer(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTestMode(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDecoCustomerApplicable(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCareCustomerApplicable(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsages(value);
      break;
    case 14:
      var value = new proto.mw.common.Image;
      reader.readMessage(value,proto.mw.common.Image.deserializeBinaryFromReader);
      msg.setMenuImage(value);
      break;
    case 15:
      var value = new proto.mw.common.Image;
      reader.readMessage(value,proto.mw.common.Image.deserializeBinaryFromReader);
      msg.setShopImage(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setInfoBox(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.SpecialOffer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.SpecialOffer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.SpecialOffer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.SpecialOffer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.mw.common.Product.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getValidFrom();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getValidUntil();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRemovesShippingCosts();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getOnlineDiscountApplicable();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMaxQuantityPerCustomer();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTestMode();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDecoCustomerApplicable();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getCareCustomerApplicable();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUsages();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getMenuImage();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.mw.common.Image.serializeBinaryToWriter
    );
  }
  f = message.getShopImage();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.mw.common.Image.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getInfoBox();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.mw.common.SpecialOffer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Product product = 2;
 * @return {?proto.mw.common.Product}
 */
proto.mw.common.SpecialOffer.prototype.getProduct = function() {
  return /** @type{?proto.mw.common.Product} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Product, 2));
};


/**
 * @param {?proto.mw.common.Product|undefined} value
 * @return {!proto.mw.common.SpecialOffer} returns this
*/
proto.mw.common.SpecialOffer.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.SpecialOffer.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SpecialOfferType type = 3;
 * @return {!proto.mw.common.SpecialOfferType}
 */
proto.mw.common.SpecialOffer.prototype.getType = function() {
  return /** @type {!proto.mw.common.SpecialOfferType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.mw.common.SpecialOfferType} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string valid_from = 4;
 * @return {string}
 */
proto.mw.common.SpecialOffer.prototype.getValidFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setValidFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string valid_until = 5;
 * @return {string}
 */
proto.mw.common.SpecialOffer.prototype.getValidUntil = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setValidUntil = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool removes_shipping_costs = 6;
 * @return {boolean}
 */
proto.mw.common.SpecialOffer.prototype.getRemovesShippingCosts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setRemovesShippingCosts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool online_discount_applicable = 7;
 * @return {boolean}
 */
proto.mw.common.SpecialOffer.prototype.getOnlineDiscountApplicable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setOnlineDiscountApplicable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional int32 max_quantity_per_customer = 8;
 * @return {number}
 */
proto.mw.common.SpecialOffer.prototype.getMaxQuantityPerCustomer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setMaxQuantityPerCustomer = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool test_mode = 9;
 * @return {boolean}
 */
proto.mw.common.SpecialOffer.prototype.getTestMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setTestMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool deco_customer_applicable = 10;
 * @return {boolean}
 */
proto.mw.common.SpecialOffer.prototype.getDecoCustomerApplicable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setDecoCustomerApplicable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool care_customer_applicable = 11;
 * @return {boolean}
 */
proto.mw.common.SpecialOffer.prototype.getCareCustomerApplicable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setCareCustomerApplicable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string description = 12;
 * @return {string}
 */
proto.mw.common.SpecialOffer.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 usages = 13;
 * @return {number}
 */
proto.mw.common.SpecialOffer.prototype.getUsages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setUsages = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional Image menu_image = 14;
 * @return {?proto.mw.common.Image}
 */
proto.mw.common.SpecialOffer.prototype.getMenuImage = function() {
  return /** @type{?proto.mw.common.Image} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Image, 14));
};


/**
 * @param {?proto.mw.common.Image|undefined} value
 * @return {!proto.mw.common.SpecialOffer} returns this
*/
proto.mw.common.SpecialOffer.prototype.setMenuImage = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.clearMenuImage = function() {
  return this.setMenuImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.SpecialOffer.prototype.hasMenuImage = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Image shop_image = 15;
 * @return {?proto.mw.common.Image}
 */
proto.mw.common.SpecialOffer.prototype.getShopImage = function() {
  return /** @type{?proto.mw.common.Image} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Image, 15));
};


/**
 * @param {?proto.mw.common.Image|undefined} value
 * @return {!proto.mw.common.SpecialOffer} returns this
*/
proto.mw.common.SpecialOffer.prototype.setShopImage = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.clearShopImage = function() {
  return this.setShopImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.SpecialOffer.prototype.hasShopImage = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string created_at = 16;
 * @return {string}
 */
proto.mw.common.SpecialOffer.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string updated_at = 17;
 * @return {string}
 */
proto.mw.common.SpecialOffer.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string info_box = 18;
 * @return {string}
 */
proto.mw.common.SpecialOffer.prototype.getInfoBox = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SpecialOffer} returns this
 */
proto.mw.common.SpecialOffer.prototype.setInfoBox = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.Image.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.Image.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.Image} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Image.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
specialOfferId: jspb.Message.getFieldWithDefault(msg, 2, ""),
productId: jspb.Message.getFieldWithDefault(msg, 3, ""),
imageType: jspb.Message.getFieldWithDefault(msg, 4, 0),
name: jspb.Message.getFieldWithDefault(msg, 5, ""),
fileType: jspb.Message.getFieldWithDefault(msg, 6, ""),
mimeType: jspb.Message.getFieldWithDefault(msg, 7, ""),
size: jspb.Message.getFieldWithDefault(msg, 8, 0),
height: jspb.Message.getFieldWithDefault(msg, 9, 0),
width: jspb.Message.getFieldWithDefault(msg, 10, 0),
etag: jspb.Message.getFieldWithDefault(msg, 11, ""),
canonical: jspb.Message.getFieldWithDefault(msg, 12, ""),
url: jspb.Message.getFieldWithDefault(msg, 13, ""),
data: msg.getData_asB64(),
createdAt: jspb.Message.getFieldWithDefault(msg, 15, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 16, ""),
deletedAt: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.Image}
 */
proto.mw.common.Image.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.Image;
  return proto.mw.common.Image.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.Image} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.Image}
 */
proto.mw.common.Image.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpecialOfferId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 4:
      var value = /** @type {!proto.mw.common.ImageType} */ (reader.readEnum());
      msg.setImageType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEtag(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCanonical(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 14:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.Image.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.Image.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.Image} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Image.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSpecialOfferId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getImageType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFileType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getEtag();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCanonical();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      14,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getDeletedAt();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.mw.common.Image.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string special_offer_id = 2;
 * @return {string}
 */
proto.mw.common.Image.prototype.getSpecialOfferId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setSpecialOfferId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.mw.common.Image.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ImageType image_type = 4;
 * @return {!proto.mw.common.ImageType}
 */
proto.mw.common.Image.prototype.getImageType = function() {
  return /** @type {!proto.mw.common.ImageType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.mw.common.ImageType} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setImageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.mw.common.Image.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string file_type = 6;
 * @return {string}
 */
proto.mw.common.Image.prototype.getFileType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setFileType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string mime_type = 7;
 * @return {string}
 */
proto.mw.common.Image.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 size = 8;
 * @return {number}
 */
proto.mw.common.Image.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 height = 9;
 * @return {number}
 */
proto.mw.common.Image.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 width = 10;
 * @return {number}
 */
proto.mw.common.Image.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string etag = 11;
 * @return {string}
 */
proto.mw.common.Image.prototype.getEtag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setEtag = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string canonical = 12;
 * @return {string}
 */
proto.mw.common.Image.prototype.getCanonical = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setCanonical = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string url = 13;
 * @return {string}
 */
proto.mw.common.Image.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bytes data = 14;
 * @return {!(string|Uint8Array)}
 */
proto.mw.common.Image.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * optional bytes data = 14;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.mw.common.Image.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 14;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.mw.common.Image.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 14, value);
};


/**
 * optional string created_at = 15;
 * @return {string}
 */
proto.mw.common.Image.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string updated_at = 16;
 * @return {string}
 */
proto.mw.common.Image.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string deleted_at = 17;
 * @return {string}
 */
proto.mw.common.Image.prototype.getDeletedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Image} returns this
 */
proto.mw.common.Image.prototype.setDeletedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.MiniShop.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.MiniShop.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.MiniShop.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.MiniShop} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.MiniShop.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
paypalDescription: jspb.Message.getFieldWithDefault(msg, 6, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 8, ""),
deletedAt: jspb.Message.getFieldWithDefault(msg, 9, ""),
specialOffersList: jspb.Message.toObjectList(msg.getSpecialOffersList(),
    proto.mw.common.SpecialOffer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.MiniShop}
 */
proto.mw.common.MiniShop.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.MiniShop;
  return proto.mw.common.MiniShop.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.MiniShop} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.MiniShop}
 */
proto.mw.common.MiniShop.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaypalDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeletedAt(value);
      break;
    case 10:
      var value = new proto.mw.common.SpecialOffer;
      reader.readMessage(value,proto.mw.common.SpecialOffer.deserializeBinaryFromReader);
      msg.addSpecialOffers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.MiniShop.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.MiniShop.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.MiniShop} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.MiniShop.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getPaypalDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDeletedAt();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSpecialOffersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.mw.common.SpecialOffer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.mw.common.MiniShop.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.MiniShop} returns this
 */
proto.mw.common.MiniShop.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.mw.common.MiniShop.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.MiniShop} returns this
 */
proto.mw.common.MiniShop.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.mw.common.MiniShop.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.MiniShop} returns this
 */
proto.mw.common.MiniShop.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string paypal_description = 6;
 * @return {string}
 */
proto.mw.common.MiniShop.prototype.getPaypalDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.MiniShop} returns this
 */
proto.mw.common.MiniShop.prototype.setPaypalDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string created_at = 7;
 * @return {string}
 */
proto.mw.common.MiniShop.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.MiniShop} returns this
 */
proto.mw.common.MiniShop.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string updated_at = 8;
 * @return {string}
 */
proto.mw.common.MiniShop.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.MiniShop} returns this
 */
proto.mw.common.MiniShop.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string deleted_at = 9;
 * @return {string}
 */
proto.mw.common.MiniShop.prototype.getDeletedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.MiniShop} returns this
 */
proto.mw.common.MiniShop.prototype.setDeletedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated SpecialOffer special_offers = 10;
 * @return {!Array<!proto.mw.common.SpecialOffer>}
 */
proto.mw.common.MiniShop.prototype.getSpecialOffersList = function() {
  return /** @type{!Array<!proto.mw.common.SpecialOffer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.SpecialOffer, 10));
};


/**
 * @param {!Array<!proto.mw.common.SpecialOffer>} value
 * @return {!proto.mw.common.MiniShop} returns this
*/
proto.mw.common.MiniShop.prototype.setSpecialOffersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.mw.common.SpecialOffer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.SpecialOffer}
 */
proto.mw.common.MiniShop.prototype.addSpecialOffers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.mw.common.SpecialOffer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.MiniShop} returns this
 */
proto.mw.common.MiniShop.prototype.clearSpecialOffersList = function() {
  return this.setSpecialOffersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.Usage.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.Usage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.Usage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Usage.toObject = function(includeInstance, msg) {
  var f, obj = {
visitorGuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
miniShopId: jspb.Message.getFieldWithDefault(msg, 2, ""),
orderShopId: jspb.Message.getFieldWithDefault(msg, 3, ""),
referrer: jspb.Message.getFieldWithDefault(msg, 4, ""),
event: jspb.Message.getFieldWithDefault(msg, 5, 0),
agent: jspb.Message.getFieldWithDefault(msg, 6, ""),
qr: jspb.Message.getFieldWithDefault(msg, 7, 0),
details: jspb.Message.getFieldWithDefault(msg, 8, ""),
mobile: jspb.Message.getFieldWithDefault(msg, 9, 0),
tablet: jspb.Message.getFieldWithDefault(msg, 10, 0),
desktop: jspb.Message.getFieldWithDefault(msg, 11, 0),
android: jspb.Message.getFieldWithDefault(msg, 12, 0),
ios: jspb.Message.getFieldWithDefault(msg, 13, 0),
mac: jspb.Message.getFieldWithDefault(msg, 14, 0),
windows: jspb.Message.getFieldWithDefault(msg, 15, 0),
bot: jspb.Message.getFieldWithDefault(msg, 16, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 17, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 18, ""),
deletedAt: jspb.Message.getFieldWithDefault(msg, 19, ""),
gclid: jspb.Message.getFieldWithDefault(msg, 20, ""),
fbclid: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.Usage}
 */
proto.mw.common.Usage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.Usage;
  return proto.mw.common.Usage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.Usage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.Usage}
 */
proto.mw.common.Usage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisitorGuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMiniShopId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderShopId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferrer(value);
      break;
    case 5:
      var value = /** @type {!proto.mw.common.UsageType} */ (reader.readEnum());
      msg.setEvent(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgent(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQr(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetails(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMobile(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablet(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDesktop(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAndroid(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIos(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMac(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWindows(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBot(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeletedAt(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setGclid(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setFbclid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.Usage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.Usage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.Usage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.Usage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisitorGuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMiniShopId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderShopId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReferrer();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEvent();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAgent();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getQr();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getDetails();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMobile();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTablet();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getDesktop();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getAndroid();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getIos();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getMac();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getWindows();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getBot();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getDeletedAt();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getGclid();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getFbclid();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional string visitor_guid = 1;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getVisitorGuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setVisitorGuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string mini_shop_id = 2;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getMiniShopId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setMiniShopId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_shop_id = 3;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getOrderShopId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setOrderShopId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string referrer = 4;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getReferrer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setReferrer = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional UsageType event = 5;
 * @return {!proto.mw.common.UsageType}
 */
proto.mw.common.Usage.prototype.getEvent = function() {
  return /** @type {!proto.mw.common.UsageType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.mw.common.UsageType} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setEvent = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string agent = 6;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 qr = 7;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getQr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setQr = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string details = 8;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 mobile = 9;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getMobile = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setMobile = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 tablet = 10;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getTablet = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setTablet = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 desktop = 11;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getDesktop = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setDesktop = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 android = 12;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getAndroid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setAndroid = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 ios = 13;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getIos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setIos = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 mac = 14;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getMac = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setMac = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 windows = 15;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getWindows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setWindows = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 bot = 16;
 * @return {number}
 */
proto.mw.common.Usage.prototype.getBot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setBot = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string created_at = 17;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string updated_at = 18;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string deleted_at = 19;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getDeletedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setDeletedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string gclid = 20;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getGclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setGclid = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string fbclid = 21;
 * @return {string}
 */
proto.mw.common.Usage.prototype.getFbclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.Usage} returns this
 */
proto.mw.common.Usage.prototype.setFbclid = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.UsageSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.UsageSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.UsageSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.UsageSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
startDate: jspb.Message.getFieldWithDefault(msg, 1, ""),
endDate: jspb.Message.getFieldWithDefault(msg, 2, ""),
event: jspb.Message.getFieldWithDefault(msg, 3, 0),
referrer: jspb.Message.getFieldWithDefault(msg, 4, ""),
count: jspb.Message.getFieldWithDefault(msg, 5, 0),
orderCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
qrPercentage: jspb.Message.getFieldWithDefault(msg, 7, 0),
mobilePercentage: jspb.Message.getFieldWithDefault(msg, 8, 0),
tabletPercentage: jspb.Message.getFieldWithDefault(msg, 9, 0),
desktopPercentage: jspb.Message.getFieldWithDefault(msg, 10, 0),
androidPercentage: jspb.Message.getFieldWithDefault(msg, 11, 0),
iosPercentage: jspb.Message.getFieldWithDefault(msg, 12, 0),
macPercentage: jspb.Message.getFieldWithDefault(msg, 13, 0),
windowsPercentage: jspb.Message.getFieldWithDefault(msg, 14, 0),
botPercentage: jspb.Message.getFieldWithDefault(msg, 15, 0),
revenue: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.UsageSummary}
 */
proto.mw.common.UsageSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.UsageSummary;
  return proto.mw.common.UsageSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.UsageSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.UsageSummary}
 */
proto.mw.common.UsageSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    case 3:
      var value = /** @type {!proto.mw.common.UsageType} */ (reader.readEnum());
      msg.setEvent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferrer(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderCount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQrPercentage(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMobilePercentage(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTabletPercentage(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDesktopPercentage(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAndroidPercentage(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIosPercentage(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMacPercentage(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWindowsPercentage(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBotPercentage(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRevenue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.UsageSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.UsageSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.UsageSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.UsageSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEvent();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getReferrer();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOrderCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getQrPercentage();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getMobilePercentage();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTabletPercentage();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getDesktopPercentage();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getAndroidPercentage();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getIosPercentage();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getMacPercentage();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getWindowsPercentage();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getBotPercentage();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getRevenue();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string start_date = 1;
 * @return {string}
 */
proto.mw.common.UsageSummary.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string end_date = 2;
 * @return {string}
 */
proto.mw.common.UsageSummary.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional UsageType event = 3;
 * @return {!proto.mw.common.UsageType}
 */
proto.mw.common.UsageSummary.prototype.getEvent = function() {
  return /** @type {!proto.mw.common.UsageType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.mw.common.UsageType} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setEvent = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string referrer = 4;
 * @return {string}
 */
proto.mw.common.UsageSummary.prototype.getReferrer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setReferrer = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 count = 5;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 order_count = 6;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getOrderCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setOrderCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 qr_percentage = 7;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getQrPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setQrPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 mobile_percentage = 8;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getMobilePercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setMobilePercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 tablet_percentage = 9;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getTabletPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setTabletPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 desktop_percentage = 10;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getDesktopPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setDesktopPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 android_percentage = 11;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getAndroidPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setAndroidPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 ios_percentage = 12;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getIosPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setIosPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 mac_percentage = 13;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getMacPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setMacPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 windows_percentage = 14;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getWindowsPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setWindowsPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 bot_percentage = 15;
 * @return {number}
 */
proto.mw.common.UsageSummary.prototype.getBotPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setBotPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string revenue = 16;
 * @return {string}
 */
proto.mw.common.UsageSummary.prototype.getRevenue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.UsageSummary} returns this
 */
proto.mw.common.UsageSummary.prototype.setRevenue = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderForm.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderForm.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderForm.toObject = function(includeInstance, msg) {
  var f, obj = {
mainCategoriesList: jspb.Message.toObjectList(msg.getMainCategoriesList(),
    proto.mw.common.OrderFormCategory.toObject, includeInstance),
summary: (f = msg.getSummary()) && proto.mw.common.OrderSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderForm}
 */
proto.mw.common.OrderForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderForm;
  return proto.mw.common.OrderForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderForm}
 */
proto.mw.common.OrderForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.common.OrderFormCategory;
      reader.readMessage(value,proto.mw.common.OrderFormCategory.deserializeBinaryFromReader);
      msg.addMainCategories(value);
      break;
    case 2:
      var value = new proto.mw.common.OrderSummary;
      reader.readMessage(value,proto.mw.common.OrderSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMainCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.mw.common.OrderFormCategory.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.mw.common.OrderSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OrderFormCategory main_categories = 1;
 * @return {!Array<!proto.mw.common.OrderFormCategory>}
 */
proto.mw.common.OrderForm.prototype.getMainCategoriesList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormCategory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderFormCategory, 1));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormCategory>} value
 * @return {!proto.mw.common.OrderForm} returns this
*/
proto.mw.common.OrderForm.prototype.setMainCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.common.OrderFormCategory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormCategory}
 */
proto.mw.common.OrderForm.prototype.addMainCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.common.OrderFormCategory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderForm} returns this
 */
proto.mw.common.OrderForm.prototype.clearMainCategoriesList = function() {
  return this.setMainCategoriesList([]);
};


/**
 * optional OrderSummary summary = 2;
 * @return {?proto.mw.common.OrderSummary}
 */
proto.mw.common.OrderForm.prototype.getSummary = function() {
  return /** @type{?proto.mw.common.OrderSummary} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderSummary, 2));
};


/**
 * @param {?proto.mw.common.OrderSummary|undefined} value
 * @return {!proto.mw.common.OrderForm} returns this
*/
proto.mw.common.OrderForm.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderForm} returns this
 */
proto.mw.common.OrderForm.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderForm.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormCategory.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormCategory.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormCategory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormCategory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormCategory.toObject = function(includeInstance, msg) {
  var f, obj = {
categoryId: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
productGroupsList: jspb.Message.toObjectList(msg.getProductGroupsList(),
    proto.mw.common.OrderFormProductGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormCategory}
 */
proto.mw.common.OrderFormCategory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormCategory;
  return proto.mw.common.OrderFormCategory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormCategory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormCategory}
 */
proto.mw.common.OrderFormCategory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = new proto.mw.common.OrderFormProductGroup;
      reader.readMessage(value,proto.mw.common.OrderFormProductGroup.deserializeBinaryFromReader);
      msg.addProductGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormCategory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormCategory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormCategory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormCategory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.mw.common.OrderFormProductGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional string category_id = 1;
 * @return {string}
 */
proto.mw.common.OrderFormCategory.prototype.getCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormCategory} returns this
 */
proto.mw.common.OrderFormCategory.prototype.setCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.mw.common.OrderFormCategory.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormCategory} returns this
 */
proto.mw.common.OrderFormCategory.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated OrderFormProductGroup product_groups = 3;
 * @return {!Array<!proto.mw.common.OrderFormProductGroup>}
 */
proto.mw.common.OrderFormCategory.prototype.getProductGroupsList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormProductGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderFormProductGroup, 3));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormProductGroup>} value
 * @return {!proto.mw.common.OrderFormCategory} returns this
*/
proto.mw.common.OrderFormCategory.prototype.setProductGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.mw.common.OrderFormProductGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormProductGroup}
 */
proto.mw.common.OrderFormCategory.prototype.addProductGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.mw.common.OrderFormProductGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormCategory} returns this
 */
proto.mw.common.OrderFormCategory.prototype.clearProductGroupsList = function() {
  return this.setProductGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormProductGroup.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormProductGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormProductGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormProductGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
productLinesList: jspb.Message.toObjectList(msg.getProductLinesList(),
    proto.mw.common.OrderFormProductLine.toObject, includeInstance),
containsSpecialOffer: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormProductGroup}
 */
proto.mw.common.OrderFormProductGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormProductGroup;
  return proto.mw.common.OrderFormProductGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormProductGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormProductGroup}
 */
proto.mw.common.OrderFormProductGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = new proto.mw.common.OrderFormProductLine;
      reader.readMessage(value,proto.mw.common.OrderFormProductLine.deserializeBinaryFromReader);
      msg.addProductLines(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContainsSpecialOffer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormProductGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormProductGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormProductGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.mw.common.OrderFormProductLine.serializeBinaryToWriter
    );
  }
  f = message.getContainsSpecialOffer();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.mw.common.OrderFormProductGroup.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductGroup} returns this
 */
proto.mw.common.OrderFormProductGroup.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated OrderFormProductLine product_lines = 2;
 * @return {!Array<!proto.mw.common.OrderFormProductLine>}
 */
proto.mw.common.OrderFormProductGroup.prototype.getProductLinesList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormProductLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderFormProductLine, 2));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormProductLine>} value
 * @return {!proto.mw.common.OrderFormProductGroup} returns this
*/
proto.mw.common.OrderFormProductGroup.prototype.setProductLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mw.common.OrderFormProductLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormProductLine}
 */
proto.mw.common.OrderFormProductGroup.prototype.addProductLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mw.common.OrderFormProductLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormProductGroup} returns this
 */
proto.mw.common.OrderFormProductGroup.prototype.clearProductLinesList = function() {
  return this.setProductLinesList([]);
};


/**
 * optional bool contains_special_offer = 3;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductGroup.prototype.getContainsSpecialOffer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductGroup} returns this
 */
proto.mw.common.OrderFormProductGroup.prototype.setContainsSpecialOffer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormProductLine.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormProductLine.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormProductLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormProductLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductLine.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
colorNumbersList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
modelNumberPattern: jspb.Message.getFieldWithDefault(msg, 3, ""),
priceB2b: jspb.Message.getFieldWithDefault(msg, 4, ""),
priceB2c: jspb.Message.getFieldWithDefault(msg, 5, ""),
productRowMain: (f = msg.getProductRowMain()) && proto.mw.common.OrderFormProductRow.toObject(includeInstance, f),
productRowTesterA: (f = msg.getProductRowTesterA()) && proto.mw.common.OrderFormProductRow.toObject(includeInstance, f),
productRowTesterB: (f = msg.getProductRowTesterB()) && proto.mw.common.OrderFormProductRow.toObject(includeInstance, f),
productRowSachet: (f = msg.getProductRowSachet()) && proto.mw.common.OrderFormProductRow.toObject(includeInstance, f),
productRowPractice: (f = msg.getProductRowPractice()) && proto.mw.common.OrderFormProductRow.toObject(includeInstance, f),
productRowSpecial: (f = msg.getProductRowSpecial()) && proto.mw.common.OrderFormProductRow.toObject(includeInstance, f),
mainCategory: jspb.Message.getFieldWithDefault(msg, 12, 0),
variantTypeLabel: jspb.Message.getFieldWithDefault(msg, 13, ""),
containsSpecialOffer: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
containsRefillProducts: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormProductLine}
 */
proto.mw.common.OrderFormProductLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormProductLine;
  return proto.mw.common.OrderFormProductLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormProductLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormProductLine}
 */
proto.mw.common.OrderFormProductLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addColorNumbers(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelNumberPattern(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceB2b(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceB2c(value);
      break;
    case 6:
      var value = new proto.mw.common.OrderFormProductRow;
      reader.readMessage(value,proto.mw.common.OrderFormProductRow.deserializeBinaryFromReader);
      msg.setProductRowMain(value);
      break;
    case 7:
      var value = new proto.mw.common.OrderFormProductRow;
      reader.readMessage(value,proto.mw.common.OrderFormProductRow.deserializeBinaryFromReader);
      msg.setProductRowTesterA(value);
      break;
    case 8:
      var value = new proto.mw.common.OrderFormProductRow;
      reader.readMessage(value,proto.mw.common.OrderFormProductRow.deserializeBinaryFromReader);
      msg.setProductRowTesterB(value);
      break;
    case 9:
      var value = new proto.mw.common.OrderFormProductRow;
      reader.readMessage(value,proto.mw.common.OrderFormProductRow.deserializeBinaryFromReader);
      msg.setProductRowSachet(value);
      break;
    case 10:
      var value = new proto.mw.common.OrderFormProductRow;
      reader.readMessage(value,proto.mw.common.OrderFormProductRow.deserializeBinaryFromReader);
      msg.setProductRowPractice(value);
      break;
    case 11:
      var value = new proto.mw.common.OrderFormProductRow;
      reader.readMessage(value,proto.mw.common.OrderFormProductRow.deserializeBinaryFromReader);
      msg.setProductRowSpecial(value);
      break;
    case 12:
      var value = /** @type {!proto.mw.common.MainCategory} */ (reader.readEnum());
      msg.setMainCategory(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setVariantTypeLabel(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContainsSpecialOffer(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContainsRefillProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormProductLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormProductLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormProductLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getColorNumbersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getModelNumberPattern();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPriceB2b();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceB2c();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProductRowMain();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.mw.common.OrderFormProductRow.serializeBinaryToWriter
    );
  }
  f = message.getProductRowTesterA();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.mw.common.OrderFormProductRow.serializeBinaryToWriter
    );
  }
  f = message.getProductRowTesterB();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.mw.common.OrderFormProductRow.serializeBinaryToWriter
    );
  }
  f = message.getProductRowSachet();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.mw.common.OrderFormProductRow.serializeBinaryToWriter
    );
  }
  f = message.getProductRowPractice();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.mw.common.OrderFormProductRow.serializeBinaryToWriter
    );
  }
  f = message.getProductRowSpecial();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.mw.common.OrderFormProductRow.serializeBinaryToWriter
    );
  }
  f = message.getMainCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getVariantTypeLabel();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getContainsSpecialOffer();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getContainsRefillProducts();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.mw.common.OrderFormProductLine.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string color_numbers = 2;
 * @return {!Array<string>}
 */
proto.mw.common.OrderFormProductLine.prototype.getColorNumbersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setColorNumbersList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.addColorNumbers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.clearColorNumbersList = function() {
  return this.setColorNumbersList([]);
};


/**
 * optional string model_number_pattern = 3;
 * @return {string}
 */
proto.mw.common.OrderFormProductLine.prototype.getModelNumberPattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setModelNumberPattern = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string price_b2b = 4;
 * @return {string}
 */
proto.mw.common.OrderFormProductLine.prototype.getPriceB2b = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setPriceB2b = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string price_b2c = 5;
 * @return {string}
 */
proto.mw.common.OrderFormProductLine.prototype.getPriceB2c = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setPriceB2c = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional OrderFormProductRow product_row_main = 6;
 * @return {?proto.mw.common.OrderFormProductRow}
 */
proto.mw.common.OrderFormProductLine.prototype.getProductRowMain = function() {
  return /** @type{?proto.mw.common.OrderFormProductRow} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderFormProductRow, 6));
};


/**
 * @param {?proto.mw.common.OrderFormProductRow|undefined} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
*/
proto.mw.common.OrderFormProductLine.prototype.setProductRowMain = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.clearProductRowMain = function() {
  return this.setProductRowMain(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductLine.prototype.hasProductRowMain = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional OrderFormProductRow product_row_tester_a = 7;
 * @return {?proto.mw.common.OrderFormProductRow}
 */
proto.mw.common.OrderFormProductLine.prototype.getProductRowTesterA = function() {
  return /** @type{?proto.mw.common.OrderFormProductRow} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderFormProductRow, 7));
};


/**
 * @param {?proto.mw.common.OrderFormProductRow|undefined} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
*/
proto.mw.common.OrderFormProductLine.prototype.setProductRowTesterA = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.clearProductRowTesterA = function() {
  return this.setProductRowTesterA(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductLine.prototype.hasProductRowTesterA = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional OrderFormProductRow product_row_tester_b = 8;
 * @return {?proto.mw.common.OrderFormProductRow}
 */
proto.mw.common.OrderFormProductLine.prototype.getProductRowTesterB = function() {
  return /** @type{?proto.mw.common.OrderFormProductRow} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderFormProductRow, 8));
};


/**
 * @param {?proto.mw.common.OrderFormProductRow|undefined} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
*/
proto.mw.common.OrderFormProductLine.prototype.setProductRowTesterB = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.clearProductRowTesterB = function() {
  return this.setProductRowTesterB(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductLine.prototype.hasProductRowTesterB = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional OrderFormProductRow product_row_sachet = 9;
 * @return {?proto.mw.common.OrderFormProductRow}
 */
proto.mw.common.OrderFormProductLine.prototype.getProductRowSachet = function() {
  return /** @type{?proto.mw.common.OrderFormProductRow} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderFormProductRow, 9));
};


/**
 * @param {?proto.mw.common.OrderFormProductRow|undefined} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
*/
proto.mw.common.OrderFormProductLine.prototype.setProductRowSachet = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.clearProductRowSachet = function() {
  return this.setProductRowSachet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductLine.prototype.hasProductRowSachet = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional OrderFormProductRow product_row_practice = 10;
 * @return {?proto.mw.common.OrderFormProductRow}
 */
proto.mw.common.OrderFormProductLine.prototype.getProductRowPractice = function() {
  return /** @type{?proto.mw.common.OrderFormProductRow} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderFormProductRow, 10));
};


/**
 * @param {?proto.mw.common.OrderFormProductRow|undefined} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
*/
proto.mw.common.OrderFormProductLine.prototype.setProductRowPractice = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.clearProductRowPractice = function() {
  return this.setProductRowPractice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductLine.prototype.hasProductRowPractice = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional OrderFormProductRow product_row_special = 11;
 * @return {?proto.mw.common.OrderFormProductRow}
 */
proto.mw.common.OrderFormProductLine.prototype.getProductRowSpecial = function() {
  return /** @type{?proto.mw.common.OrderFormProductRow} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderFormProductRow, 11));
};


/**
 * @param {?proto.mw.common.OrderFormProductRow|undefined} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
*/
proto.mw.common.OrderFormProductLine.prototype.setProductRowSpecial = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.clearProductRowSpecial = function() {
  return this.setProductRowSpecial(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductLine.prototype.hasProductRowSpecial = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional MainCategory main_category = 12;
 * @return {!proto.mw.common.MainCategory}
 */
proto.mw.common.OrderFormProductLine.prototype.getMainCategory = function() {
  return /** @type {!proto.mw.common.MainCategory} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.mw.common.MainCategory} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setMainCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional string variant_type_label = 13;
 * @return {string}
 */
proto.mw.common.OrderFormProductLine.prototype.getVariantTypeLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setVariantTypeLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool contains_special_offer = 14;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductLine.prototype.getContainsSpecialOffer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setContainsSpecialOffer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool contains_refill_products = 15;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductLine.prototype.getContainsRefillProducts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductLine} returns this
 */
proto.mw.common.OrderFormProductLine.prototype.setContainsRefillProducts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormProductRow.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormProductRow.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormProductRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormProductRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductRow.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
productCellList: jspb.Message.toObjectList(msg.getProductCellList(),
    proto.mw.common.OrderFormProductCell.toObject, includeInstance),
priceB2b: jspb.Message.getFieldWithDefault(msg, 3, ""),
containsSpecialOffer: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormProductRow}
 */
proto.mw.common.OrderFormProductRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormProductRow;
  return proto.mw.common.OrderFormProductRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormProductRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormProductRow}
 */
proto.mw.common.OrderFormProductRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = new proto.mw.common.OrderFormProductCell;
      reader.readMessage(value,proto.mw.common.OrderFormProductCell.deserializeBinaryFromReader);
      msg.addProductCell(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceB2b(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContainsSpecialOffer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormProductRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormProductRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormProductRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductCellList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.mw.common.OrderFormProductCell.serializeBinaryToWriter
    );
  }
  f = message.getPriceB2b();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContainsSpecialOffer();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.mw.common.OrderFormProductRow.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductRow} returns this
 */
proto.mw.common.OrderFormProductRow.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated OrderFormProductCell product_cell = 2;
 * @return {!Array<!proto.mw.common.OrderFormProductCell>}
 */
proto.mw.common.OrderFormProductRow.prototype.getProductCellList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormProductCell>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderFormProductCell, 2));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormProductCell>} value
 * @return {!proto.mw.common.OrderFormProductRow} returns this
*/
proto.mw.common.OrderFormProductRow.prototype.setProductCellList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mw.common.OrderFormProductCell=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormProductCell}
 */
proto.mw.common.OrderFormProductRow.prototype.addProductCell = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mw.common.OrderFormProductCell, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormProductRow} returns this
 */
proto.mw.common.OrderFormProductRow.prototype.clearProductCellList = function() {
  return this.setProductCellList([]);
};


/**
 * optional string price_b2b = 3;
 * @return {string}
 */
proto.mw.common.OrderFormProductRow.prototype.getPriceB2b = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductRow} returns this
 */
proto.mw.common.OrderFormProductRow.prototype.setPriceB2b = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool contains_special_offer = 4;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductRow.prototype.getContainsSpecialOffer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductRow} returns this
 */
proto.mw.common.OrderFormProductRow.prototype.setContainsSpecialOffer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormProductCell.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormProductCell.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormProductCell} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductCell.toObject = function(includeInstance, msg) {
  var f, obj = {
product: (f = msg.getProduct()) && proto.mw.common.Product.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 2, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
specialPrice: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
newProduct: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
expiringProduct: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
colorNumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
containsSpecialOffer: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormProductCell}
 */
proto.mw.common.OrderFormProductCell.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormProductCell;
  return proto.mw.common.OrderFormProductCell.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormProductCell} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormProductCell}
 */
proto.mw.common.OrderFormProductCell.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.common.Product;
      reader.readMessage(value,proto.mw.common.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSpecialPrice(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewProduct(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExpiringProduct(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setColorNumber(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContainsSpecialOffer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormProductCell.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormProductCell.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormProductCell} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductCell.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.mw.common.Product.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSpecialPrice();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getNewProduct();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getExpiringProduct();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getColorNumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getContainsSpecialOffer();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional Product product = 1;
 * @return {?proto.mw.common.Product}
 */
proto.mw.common.OrderFormProductCell.prototype.getProduct = function() {
  return /** @type{?proto.mw.common.Product} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Product, 1));
};


/**
 * @param {?proto.mw.common.Product|undefined} value
 * @return {!proto.mw.common.OrderFormProductCell} returns this
*/
proto.mw.common.OrderFormProductCell.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductCell} returns this
 */
proto.mw.common.OrderFormProductCell.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductCell.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.mw.common.OrderFormProductCell.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductCell} returns this
 */
proto.mw.common.OrderFormProductCell.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 quantity = 3;
 * @return {number}
 */
proto.mw.common.OrderFormProductCell.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderFormProductCell} returns this
 */
proto.mw.common.OrderFormProductCell.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool special_price = 4;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductCell.prototype.getSpecialPrice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductCell} returns this
 */
proto.mw.common.OrderFormProductCell.prototype.setSpecialPrice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool new_product = 5;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductCell.prototype.getNewProduct = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductCell} returns this
 */
proto.mw.common.OrderFormProductCell.prototype.setNewProduct = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool expiring_product = 6;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductCell.prototype.getExpiringProduct = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductCell} returns this
 */
proto.mw.common.OrderFormProductCell.prototype.setExpiringProduct = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string color_number = 7;
 * @return {string}
 */
proto.mw.common.OrderFormProductCell.prototype.getColorNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProductCell} returns this
 */
proto.mw.common.OrderFormProductCell.prototype.setColorNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool contains_special_offer = 8;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductCell.prototype.getContainsSpecialOffer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductCell} returns this
 */
proto.mw.common.OrderFormProductCell.prototype.setContainsSpecialOffer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
productId: jspb.Message.getFieldWithDefault(msg, 2, 0),
product: (f = msg.getProduct()) && proto.mw.common.Product.toObject(includeInstance, f),
orderForm: jspb.Message.getFieldWithDefault(msg, 4, ""),
status: jspb.Message.getFieldWithDefault(msg, 5, 0),
category: jspb.Message.getFieldWithDefault(msg, 6, ""),
productLineNumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
productLineName: jspb.Message.getFieldWithDefault(msg, 8, ""),
productLinePriceDefiner: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
columnName: jspb.Message.getFieldWithDefault(msg, 10, ""),
columnsDescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
rowName: jspb.Message.getFieldWithDefault(msg, 12, ""),
modelNumber: jspb.Message.getFieldWithDefault(msg, 13, ""),
productName: jspb.Message.getFieldWithDefault(msg, 14, ""),
variantName: jspb.Message.getFieldWithDefault(msg, 20, ""),
productDescription: jspb.Message.getFieldWithDefault(msg, 15, ""),
productUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
imageUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 18, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 19, ""),
subCategory: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormProduct}
 */
proto.mw.common.OrderFormProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormProduct;
  return proto.mw.common.OrderFormProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormProduct}
 */
proto.mw.common.OrderFormProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setProductId(value);
      break;
    case 3:
      var value = new proto.mw.common.Product;
      reader.readMessage(value,proto.mw.common.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderForm(value);
      break;
    case 5:
      var value = /** @type {!proto.mw.common.OrderFormProductStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductLineNumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductLineName(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProductLinePriceDefiner(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnsDescription(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRowName(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelNumber(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setVariantName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductDescription(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductUrl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.mw.common.Product.serializeBinaryToWriter
    );
  }
  f = message.getOrderForm();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProductLineNumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProductLineName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getProductLinePriceDefiner();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getColumnName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getColumnsDescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRowName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getModelNumber();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getVariantName();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getProductDescription();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getProductUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSubCategory();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.mw.common.OrderFormProduct.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 product_id = 2;
 * @return {number}
 */
proto.mw.common.OrderFormProduct.prototype.getProductId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setProductId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Product product = 3;
 * @return {?proto.mw.common.Product}
 */
proto.mw.common.OrderFormProduct.prototype.getProduct = function() {
  return /** @type{?proto.mw.common.Product} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Product, 3));
};


/**
 * @param {?proto.mw.common.Product|undefined} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
*/
proto.mw.common.OrderFormProduct.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProduct.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string order_form = 4;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getOrderForm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setOrderForm = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional OrderFormProductStatus status = 5;
 * @return {!proto.mw.common.OrderFormProductStatus}
 */
proto.mw.common.OrderFormProduct.prototype.getStatus = function() {
  return /** @type {!proto.mw.common.OrderFormProductStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.mw.common.OrderFormProductStatus} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string category = 6;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string product_line_number = 7;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getProductLineNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setProductLineNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string product_line_name = 8;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getProductLineName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setProductLineName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool product_line_price_definer = 9;
 * @return {boolean}
 */
proto.mw.common.OrderFormProduct.prototype.getProductLinePriceDefiner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setProductLinePriceDefiner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string column_name = 10;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getColumnName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setColumnName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string columns_description = 11;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getColumnsDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setColumnsDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string row_name = 12;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getRowName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setRowName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string model_number = 13;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getModelNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setModelNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string product_name = 14;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string variant_name = 20;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getVariantName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setVariantName = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string product_description = 15;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getProductDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setProductDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string product_url = 16;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getProductUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setProductUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string image_url = 17;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string created_at = 18;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string updated_at = 19;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string sub_category = 21;
 * @return {string}
 */
proto.mw.common.OrderFormProduct.prototype.getSubCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormProduct} returns this
 */
proto.mw.common.OrderFormProduct.prototype.setSubCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormProductDisplay.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormProductDisplay.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormProductDisplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormProductDisplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductDisplay.toObject = function(includeInstance, msg) {
  var f, obj = {
product: (f = msg.getProduct()) && proto.mw.common.Product.toObject(includeInstance, f),
orderFormData: (f = msg.getOrderFormData()) && proto.mw.common.OrderFormProduct.toObject(includeInstance, f),
hideReasonsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
isVisible: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
isMuted: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormProductDisplay}
 */
proto.mw.common.OrderFormProductDisplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormProductDisplay;
  return proto.mw.common.OrderFormProductDisplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormProductDisplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormProductDisplay}
 */
proto.mw.common.OrderFormProductDisplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.common.Product;
      reader.readMessage(value,proto.mw.common.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 2:
      var value = new proto.mw.common.OrderFormProduct;
      reader.readMessage(value,proto.mw.common.OrderFormProduct.deserializeBinaryFromReader);
      msg.setOrderFormData(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addHideReasons(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVisible(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMuted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormProductDisplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormProductDisplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormProductDisplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormProductDisplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.mw.common.Product.serializeBinaryToWriter
    );
  }
  f = message.getOrderFormData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.mw.common.OrderFormProduct.serializeBinaryToWriter
    );
  }
  f = message.getHideReasonsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getIsVisible();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIsMuted();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional Product product = 1;
 * @return {?proto.mw.common.Product}
 */
proto.mw.common.OrderFormProductDisplay.prototype.getProduct = function() {
  return /** @type{?proto.mw.common.Product} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Product, 1));
};


/**
 * @param {?proto.mw.common.Product|undefined} value
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
*/
proto.mw.common.OrderFormProductDisplay.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
 */
proto.mw.common.OrderFormProductDisplay.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductDisplay.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OrderFormProduct order_form_data = 2;
 * @return {?proto.mw.common.OrderFormProduct}
 */
proto.mw.common.OrderFormProductDisplay.prototype.getOrderFormData = function() {
  return /** @type{?proto.mw.common.OrderFormProduct} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.OrderFormProduct, 2));
};


/**
 * @param {?proto.mw.common.OrderFormProduct|undefined} value
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
*/
proto.mw.common.OrderFormProductDisplay.prototype.setOrderFormData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
 */
proto.mw.common.OrderFormProductDisplay.prototype.clearOrderFormData = function() {
  return this.setOrderFormData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.OrderFormProductDisplay.prototype.hasOrderFormData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string hide_reasons = 3;
 * @return {!Array<string>}
 */
proto.mw.common.OrderFormProductDisplay.prototype.getHideReasonsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
 */
proto.mw.common.OrderFormProductDisplay.prototype.setHideReasonsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
 */
proto.mw.common.OrderFormProductDisplay.prototype.addHideReasons = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
 */
proto.mw.common.OrderFormProductDisplay.prototype.clearHideReasonsList = function() {
  return this.setHideReasonsList([]);
};


/**
 * optional bool is_visible = 4;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductDisplay.prototype.getIsVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
 */
proto.mw.common.OrderFormProductDisplay.prototype.setIsVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool is_muted = 5;
 * @return {boolean}
 */
proto.mw.common.OrderFormProductDisplay.prototype.getIsMuted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.OrderFormProductDisplay} returns this
 */
proto.mw.common.OrderFormProductDisplay.prototype.setIsMuted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.PreviewCustomerProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.PreviewCustomerProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.PreviewCustomerProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.PreviewCustomerProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
careProducts: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
decoProducts: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
detoxProducts: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
hairdresserProducts: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.PreviewCustomerProfile}
 */
proto.mw.common.PreviewCustomerProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.PreviewCustomerProfile;
  return proto.mw.common.PreviewCustomerProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.PreviewCustomerProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.PreviewCustomerProfile}
 */
proto.mw.common.PreviewCustomerProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCareProducts(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDecoProducts(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDetoxProducts(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHairdresserProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.PreviewCustomerProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.PreviewCustomerProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.PreviewCustomerProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.PreviewCustomerProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCareProducts();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getDecoProducts();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDetoxProducts();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getHairdresserProducts();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool care_products = 1;
 * @return {boolean}
 */
proto.mw.common.PreviewCustomerProfile.prototype.getCareProducts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.PreviewCustomerProfile} returns this
 */
proto.mw.common.PreviewCustomerProfile.prototype.setCareProducts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool deco_products = 2;
 * @return {boolean}
 */
proto.mw.common.PreviewCustomerProfile.prototype.getDecoProducts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.PreviewCustomerProfile} returns this
 */
proto.mw.common.PreviewCustomerProfile.prototype.setDecoProducts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool detox_products = 3;
 * @return {boolean}
 */
proto.mw.common.PreviewCustomerProfile.prototype.getDetoxProducts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.PreviewCustomerProfile} returns this
 */
proto.mw.common.PreviewCustomerProfile.prototype.setDetoxProducts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool hairdresser_products = 4;
 * @return {boolean}
 */
proto.mw.common.PreviewCustomerProfile.prototype.getHairdresserProducts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.PreviewCustomerProfile} returns this
 */
proto.mw.common.PreviewCustomerProfile.prototype.setHairdresserProducts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.PreviewStatistics.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.PreviewStatistics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.PreviewStatistics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.PreviewStatistics.toObject = function(includeInstance, msg) {
  var f, obj = {
totalProducts: jspb.Message.getFieldWithDefault(msg, 1, 0),
visibleProducts: jspb.Message.getFieldWithDefault(msg, 2, 0),
hiddenProducts: jspb.Message.getFieldWithDefault(msg, 3, 0),
hiddenByReasonMap: (f = msg.getHiddenByReasonMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.PreviewStatistics}
 */
proto.mw.common.PreviewStatistics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.PreviewStatistics;
  return proto.mw.common.PreviewStatistics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.PreviewStatistics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.PreviewStatistics}
 */
proto.mw.common.PreviewStatistics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalProducts(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVisibleProducts(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHiddenProducts(value);
      break;
    case 4:
      var value = msg.getHiddenByReasonMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.PreviewStatistics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.PreviewStatistics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.PreviewStatistics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.PreviewStatistics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalProducts();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVisibleProducts();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getHiddenProducts();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHiddenByReasonMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
};


/**
 * optional int32 total_products = 1;
 * @return {number}
 */
proto.mw.common.PreviewStatistics.prototype.getTotalProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.PreviewStatistics} returns this
 */
proto.mw.common.PreviewStatistics.prototype.setTotalProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 visible_products = 2;
 * @return {number}
 */
proto.mw.common.PreviewStatistics.prototype.getVisibleProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.PreviewStatistics} returns this
 */
proto.mw.common.PreviewStatistics.prototype.setVisibleProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 hidden_products = 3;
 * @return {number}
 */
proto.mw.common.PreviewStatistics.prototype.getHiddenProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.PreviewStatistics} returns this
 */
proto.mw.common.PreviewStatistics.prototype.setHiddenProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * map<string, int32> hidden_by_reason = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.mw.common.PreviewStatistics.prototype.getHiddenByReasonMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.PreviewStatistics} returns this
 */
proto.mw.common.PreviewStatistics.prototype.clearHiddenByReasonMap = function() {
  this.getHiddenByReasonMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormV2Category.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormV2Category.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormV2Category.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormV2Category} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2Category.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
productLinesList: jspb.Message.toObjectList(msg.getProductLinesList(),
    proto.mw.common.OrderFormV2ProductLine.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormV2Category}
 */
proto.mw.common.OrderFormV2Category.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormV2Category;
  return proto.mw.common.OrderFormV2Category.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormV2Category} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormV2Category}
 */
proto.mw.common.OrderFormV2Category.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.mw.common.OrderFormV2ProductLine;
      reader.readMessage(value,proto.mw.common.OrderFormV2ProductLine.deserializeBinaryFromReader);
      msg.addProductLines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormV2Category.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormV2Category.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormV2Category} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2Category.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.mw.common.OrderFormV2ProductLine.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.mw.common.OrderFormV2Category.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2Category} returns this
 */
proto.mw.common.OrderFormV2Category.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated OrderFormV2ProductLine product_lines = 2;
 * @return {!Array<!proto.mw.common.OrderFormV2ProductLine>}
 */
proto.mw.common.OrderFormV2Category.prototype.getProductLinesList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormV2ProductLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderFormV2ProductLine, 2));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormV2ProductLine>} value
 * @return {!proto.mw.common.OrderFormV2Category} returns this
*/
proto.mw.common.OrderFormV2Category.prototype.setProductLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mw.common.OrderFormV2ProductLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormV2ProductLine}
 */
proto.mw.common.OrderFormV2Category.prototype.addProductLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mw.common.OrderFormV2ProductLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormV2Category} returns this
 */
proto.mw.common.OrderFormV2Category.prototype.clearProductLinesList = function() {
  return this.setProductLinesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormV2ProductLine.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormV2ProductLine.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormV2ProductLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormV2ProductLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2ProductLine.toObject = function(includeInstance, msg) {
  var f, obj = {
number: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.mw.common.OrderFormProductDisplay.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormV2ProductLine}
 */
proto.mw.common.OrderFormV2ProductLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormV2ProductLine;
  return proto.mw.common.OrderFormV2ProductLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormV2ProductLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormV2ProductLine}
 */
proto.mw.common.OrderFormV2ProductLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.mw.common.OrderFormProductDisplay;
      reader.readMessage(value,proto.mw.common.OrderFormProductDisplay.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormV2ProductLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormV2ProductLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormV2ProductLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2ProductLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.mw.common.OrderFormProductDisplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional string number = 1;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductLine.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductLine} returns this
 */
proto.mw.common.OrderFormV2ProductLine.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductLine.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductLine} returns this
 */
proto.mw.common.OrderFormV2ProductLine.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated OrderFormProductDisplay products = 3;
 * @return {!Array<!proto.mw.common.OrderFormProductDisplay>}
 */
proto.mw.common.OrderFormV2ProductLine.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormProductDisplay>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderFormProductDisplay, 3));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormProductDisplay>} value
 * @return {!proto.mw.common.OrderFormV2ProductLine} returns this
*/
proto.mw.common.OrderFormV2ProductLine.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.mw.common.OrderFormProductDisplay=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormProductDisplay}
 */
proto.mw.common.OrderFormV2ProductLine.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.mw.common.OrderFormProductDisplay, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormV2ProductLine} returns this
 */
proto.mw.common.OrderFormV2ProductLine.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormV2CategoryGrouped.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormV2CategoryGrouped.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormV2CategoryGrouped.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormV2CategoryGrouped} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2CategoryGrouped.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
productGroupsList: jspb.Message.toObjectList(msg.getProductGroupsList(),
    proto.mw.common.OrderFormV2ProductGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormV2CategoryGrouped}
 */
proto.mw.common.OrderFormV2CategoryGrouped.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormV2CategoryGrouped;
  return proto.mw.common.OrderFormV2CategoryGrouped.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormV2CategoryGrouped} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormV2CategoryGrouped}
 */
proto.mw.common.OrderFormV2CategoryGrouped.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = new proto.mw.common.OrderFormV2ProductGroup;
      reader.readMessage(value,proto.mw.common.OrderFormV2ProductGroup.deserializeBinaryFromReader);
      msg.addProductGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormV2CategoryGrouped.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormV2CategoryGrouped.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormV2CategoryGrouped} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2CategoryGrouped.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.mw.common.OrderFormV2ProductGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.mw.common.OrderFormV2CategoryGrouped.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2CategoryGrouped} returns this
 */
proto.mw.common.OrderFormV2CategoryGrouped.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated OrderFormV2ProductGroup product_groups = 2;
 * @return {!Array<!proto.mw.common.OrderFormV2ProductGroup>}
 */
proto.mw.common.OrderFormV2CategoryGrouped.prototype.getProductGroupsList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormV2ProductGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderFormV2ProductGroup, 2));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormV2ProductGroup>} value
 * @return {!proto.mw.common.OrderFormV2CategoryGrouped} returns this
*/
proto.mw.common.OrderFormV2CategoryGrouped.prototype.setProductGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mw.common.OrderFormV2ProductGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormV2ProductGroup}
 */
proto.mw.common.OrderFormV2CategoryGrouped.prototype.addProductGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mw.common.OrderFormV2ProductGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormV2CategoryGrouped} returns this
 */
proto.mw.common.OrderFormV2CategoryGrouped.prototype.clearProductGroupsList = function() {
  return this.setProductGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormV2ProductGroup.repeatedFields_ = [7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormV2ProductGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormV2ProductGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2ProductGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
code: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
priceInfo: jspb.Message.getFieldWithDefault(msg, 3, ""),
priceB2b: jspb.Message.getFieldWithDefault(msg, 4, ""),
priceB2c: jspb.Message.getFieldWithDefault(msg, 5, ""),
columnsDescription: jspb.Message.getFieldWithDefault(msg, 6, ""),
columnValuesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.mw.common.OrderFormV2Row.toObject, includeInstance),
subCategory: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormV2ProductGroup}
 */
proto.mw.common.OrderFormV2ProductGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormV2ProductGroup;
  return proto.mw.common.OrderFormV2ProductGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormV2ProductGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormV2ProductGroup}
 */
proto.mw.common.OrderFormV2ProductGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceInfo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceB2b(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceB2c(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnsDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addColumnValues(value);
      break;
    case 8:
      var value = new proto.mw.common.OrderFormV2Row;
      reader.readMessage(value,proto.mw.common.OrderFormV2Row.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormV2ProductGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormV2ProductGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2ProductGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPriceInfo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPriceB2b();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceB2c();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getColumnsDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getColumnValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.mw.common.OrderFormV2Row.serializeBinaryToWriter
    );
  }
  f = message.getSubCategory();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string price_info = 3;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getPriceInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.setPriceInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string price_b2b = 4;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getPriceB2b = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.setPriceB2b = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string price_b2c = 5;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getPriceB2c = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.setPriceB2c = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string columns_description = 6;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getColumnsDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.setColumnsDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string column_values = 7;
 * @return {!Array<string>}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getColumnValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.setColumnValuesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.addColumnValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.clearColumnValuesList = function() {
  return this.setColumnValuesList([]);
};


/**
 * repeated OrderFormV2Row rows = 8;
 * @return {!Array<!proto.mw.common.OrderFormV2Row>}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormV2Row>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.common.OrderFormV2Row, 8));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormV2Row>} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
*/
proto.mw.common.OrderFormV2ProductGroup.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.mw.common.OrderFormV2Row=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormV2Row}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.mw.common.OrderFormV2Row, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};


/**
 * optional string sub_category = 9;
 * @return {string}
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.getSubCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2ProductGroup} returns this
 */
proto.mw.common.OrderFormV2ProductGroup.prototype.setSubCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.common.OrderFormV2Row.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.OrderFormV2Row.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.OrderFormV2Row.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.OrderFormV2Row} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2Row.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
availableColumnsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
unavailableReasonsMap: (f = msg.getUnavailableReasonsMap()) ? f.toObject(includeInstance, undefined) : [],
priceB2b: jspb.Message.getFieldWithDefault(msg, 4, ""),
priceB2c: jspb.Message.getFieldWithDefault(msg, 5, ""),
productIdsMap: (f = msg.getProductIdsMap()) ? f.toObject(includeInstance, undefined) : [],
modelNumbersMap: (f = msg.getModelNumbersMap()) ? f.toObject(includeInstance, undefined) : [],
ingredientsMap: (f = msg.getIngredientsMap()) ? f.toObject(includeInstance, undefined) : [],
descriptionsMap: (f = msg.getDescriptionsMap()) ? f.toObject(includeInstance, undefined) : [],
minimumOrderQuantitiesMap: (f = msg.getMinimumOrderQuantitiesMap()) ? f.toObject(includeInstance, undefined) : [],
rowSum: jspb.Message.getFieldWithDefault(msg, 11, ""),
quantitiesMap: (f = msg.getQuantitiesMap()) ? f.toObject(includeInstance, undefined) : [],
pricesB2bMap: (f = msg.getPricesB2bMap()) ? f.toObject(includeInstance, undefined) : [],
pricesB2cMap: (f = msg.getPricesB2cMap()) ? f.toObject(includeInstance, undefined) : [],
variantNamesMap: (f = msg.getVariantNamesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.OrderFormV2Row}
 */
proto.mw.common.OrderFormV2Row.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.OrderFormV2Row;
  return proto.mw.common.OrderFormV2Row.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.OrderFormV2Row} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.OrderFormV2Row}
 */
proto.mw.common.OrderFormV2Row.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAvailableColumns(value);
      break;
    case 3:
      var value = msg.getUnavailableReasonsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceB2b(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceB2c(value);
      break;
    case 6:
      var value = msg.getProductIdsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = msg.getModelNumbersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = msg.getIngredientsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 9:
      var value = msg.getDescriptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 10:
      var value = msg.getMinimumOrderQuantitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setRowSum(value);
      break;
    case 12:
      var value = msg.getQuantitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    case 13:
      var value = msg.getPricesB2bMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 14:
      var value = msg.getPricesB2cMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 15:
      var value = msg.getVariantNamesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.OrderFormV2Row.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.OrderFormV2Row.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.OrderFormV2Row} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.OrderFormV2Row.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvailableColumnsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getUnavailableReasonsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPriceB2b();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceB2c();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProductIdsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getModelNumbersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getIngredientsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getDescriptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getMinimumOrderQuantitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getRowSum();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getQuantitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(12, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getPricesB2bMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(13, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPricesB2cMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(14, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getVariantNamesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(15, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.mw.common.OrderFormV2Row.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string available_columns = 2;
 * @return {!Array<string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getAvailableColumnsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.setAvailableColumnsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.addAvailableColumns = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearAvailableColumnsList = function() {
  return this.setAvailableColumnsList([]);
};


/**
 * map<string, string> unavailable_reasons = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getUnavailableReasonsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearUnavailableReasonsMap = function() {
  this.getUnavailableReasonsMap().clear();
  return this;
};


/**
 * optional string price_b2b = 4;
 * @return {string}
 */
proto.mw.common.OrderFormV2Row.prototype.getPriceB2b = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.setPriceB2b = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string price_b2c = 5;
 * @return {string}
 */
proto.mw.common.OrderFormV2Row.prototype.getPriceB2c = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.setPriceB2c = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<string, string> product_ids = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getProductIdsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearProductIdsMap = function() {
  this.getProductIdsMap().clear();
  return this;
};


/**
 * map<string, string> model_numbers = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getModelNumbersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearModelNumbersMap = function() {
  this.getModelNumbersMap().clear();
  return this;
};


/**
 * map<string, string> ingredients = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getIngredientsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearIngredientsMap = function() {
  this.getIngredientsMap().clear();
  return this;
};


/**
 * map<string, string> descriptions = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getDescriptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearDescriptionsMap = function() {
  this.getDescriptionsMap().clear();
  return this;
};


/**
 * map<string, uint32> minimum_order_quantities = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.mw.common.OrderFormV2Row.prototype.getMinimumOrderQuantitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearMinimumOrderQuantitiesMap = function() {
  this.getMinimumOrderQuantitiesMap().clear();
  return this;
};


/**
 * optional string row_sum = 11;
 * @return {string}
 */
proto.mw.common.OrderFormV2Row.prototype.getRowSum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.setRowSum = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * map<string, uint32> quantities = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.mw.common.OrderFormV2Row.prototype.getQuantitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearQuantitiesMap = function() {
  this.getQuantitiesMap().clear();
  return this;
};


/**
 * map<string, string> prices_b2b = 13;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getPricesB2bMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 13, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearPricesB2bMap = function() {
  this.getPricesB2bMap().clear();
  return this;
};


/**
 * map<string, string> prices_b2c = 14;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getPricesB2cMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 14, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearPricesB2cMap = function() {
  this.getPricesB2cMap().clear();
  return this;
};


/**
 * map<string, string> variant_names = 15;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.common.OrderFormV2Row.prototype.getVariantNamesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 15, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.common.OrderFormV2Row} returns this
 */
proto.mw.common.OrderFormV2Row.prototype.clearVariantNamesMap = function() {
  this.getVariantNamesMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.SkinProblem.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.SkinProblem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.SkinProblem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.SkinProblem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
nameEn: jspb.Message.getFieldWithDefault(msg, 2, ""),
nameDe: jspb.Message.getFieldWithDefault(msg, 3, ""),
descriptionEn: jspb.Message.getFieldWithDefault(msg, 4, ""),
descriptionDe: jspb.Message.getFieldWithDefault(msg, 5, ""),
aiDetectable: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
askUserInput: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.SkinProblem}
 */
proto.mw.common.SkinProblem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.SkinProblem;
  return proto.mw.common.SkinProblem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.SkinProblem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.SkinProblem}
 */
proto.mw.common.SkinProblem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNameEn(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNameDe(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionEn(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionDe(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAiDetectable(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAskUserInput(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.SkinProblem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.SkinProblem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.SkinProblem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.SkinProblem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNameEn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNameDe();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescriptionEn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescriptionDe();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAiDetectable();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAskUserInput();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.mw.common.SkinProblem.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.SkinProblem} returns this
 */
proto.mw.common.SkinProblem.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name_en = 2;
 * @return {string}
 */
proto.mw.common.SkinProblem.prototype.getNameEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SkinProblem} returns this
 */
proto.mw.common.SkinProblem.prototype.setNameEn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name_de = 3;
 * @return {string}
 */
proto.mw.common.SkinProblem.prototype.getNameDe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SkinProblem} returns this
 */
proto.mw.common.SkinProblem.prototype.setNameDe = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description_en = 4;
 * @return {string}
 */
proto.mw.common.SkinProblem.prototype.getDescriptionEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SkinProblem} returns this
 */
proto.mw.common.SkinProblem.prototype.setDescriptionEn = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description_de = 5;
 * @return {string}
 */
proto.mw.common.SkinProblem.prototype.getDescriptionDe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.SkinProblem} returns this
 */
proto.mw.common.SkinProblem.prototype.setDescriptionDe = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool ai_detectable = 6;
 * @return {boolean}
 */
proto.mw.common.SkinProblem.prototype.getAiDetectable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.SkinProblem} returns this
 */
proto.mw.common.SkinProblem.prototype.setAiDetectable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool ask_user_input = 7;
 * @return {boolean}
 */
proto.mw.common.SkinProblem.prototype.getAskUserInput = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.common.SkinProblem} returns this
 */
proto.mw.common.SkinProblem.prototype.setAskUserInput = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.common.ProductSkinProblemEffectiveness.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.common.ProductSkinProblemEffectiveness} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.ProductSkinProblemEffectiveness.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
productId: jspb.Message.getFieldWithDefault(msg, 2, 0),
product: (f = msg.getProduct()) && proto.mw.common.Product.toObject(includeInstance, f),
skinProblemId: jspb.Message.getFieldWithDefault(msg, 4, 0),
skinProblem: (f = msg.getSkinProblem()) && proto.mw.common.SkinProblem.toObject(includeInstance, f),
score: jspb.Message.getFieldWithDefault(msg, 6, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness}
 */
proto.mw.common.ProductSkinProblemEffectiveness.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.common.ProductSkinProblemEffectiveness;
  return proto.mw.common.ProductSkinProblemEffectiveness.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.common.ProductSkinProblemEffectiveness} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness}
 */
proto.mw.common.ProductSkinProblemEffectiveness.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProductId(value);
      break;
    case 3:
      var value = new proto.mw.common.Product;
      reader.readMessage(value,proto.mw.common.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSkinProblemId(value);
      break;
    case 5:
      var value = new proto.mw.common.SkinProblem;
      reader.readMessage(value,proto.mw.common.SkinProblem.deserializeBinaryFromReader);
      msg.setSkinProblem(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setScore(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.common.ProductSkinProblemEffectiveness.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.common.ProductSkinProblemEffectiveness} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.common.ProductSkinProblemEffectiveness.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.mw.common.Product.serializeBinaryToWriter
    );
  }
  f = message.getSkinProblemId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getSkinProblem();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.mw.common.SkinProblem.serializeBinaryToWriter
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 product_id = 2;
 * @return {number}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.getProductId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.setProductId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Product product = 3;
 * @return {?proto.mw.common.Product}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.getProduct = function() {
  return /** @type{?proto.mw.common.Product} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.Product, 3));
};


/**
 * @param {?proto.mw.common.Product|undefined} value
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
*/
proto.mw.common.ProductSkinProblemEffectiveness.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 skin_problem_id = 4;
 * @return {number}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.getSkinProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.setSkinProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional SkinProblem skin_problem = 5;
 * @return {?proto.mw.common.SkinProblem}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.getSkinProblem = function() {
  return /** @type{?proto.mw.common.SkinProblem} */ (
    jspb.Message.getWrapperField(this, proto.mw.common.SkinProblem, 5));
};


/**
 * @param {?proto.mw.common.SkinProblem|undefined} value
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
*/
proto.mw.common.ProductSkinProblemEffectiveness.prototype.setSkinProblem = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.clearSkinProblem = function() {
  return this.setSkinProblem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.hasSkinProblem = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint32 score = 6;
 * @return {number}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.setScore = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string created_at = 7;
 * @return {string}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string updated_at = 8;
 * @return {string}
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.common.ProductSkinProblemEffectiveness} returns this
 */
proto.mw.common.ProductSkinProblemEffectiveness.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * @enum {number}
 */
proto.mw.common.MainCategory = {
  MAIN_CATEGORY_INVALID: 0,
  MAIN_CATEGORY_OFFERS: 1,
  MAIN_CATEGORY_DECO: 2,
  MAIN_CATEGORY_CARE: 3,
  MAIN_CATEGORY_PROMOTION: 4
};

/**
 * @enum {number}
 */
proto.mw.common.AddressType = {
  ADDRESS_TYPE_INVALID: 0,
  ADDRESS_TYPE_INVOICE: 1,
  ADDRESS_TYPE_DELIVERY: 2
};

/**
 * @enum {number}
 */
proto.mw.common.OrderStatus = {
  ORDER_STATUS_INVALID: 0,
  ORDER_STATUS_CREATED: 1,
  ORDER_STATUS_PROCESSED: 2,
  ORDER_STATUS_SHIPPED: 3,
  ORDER_STATUS_CANCELED: 4,
  ORDER_STATUS_INTENT: 5,
  ORDER_STATUS_INTENT_ERROR: 6,
  ORDER_STATUS_CAPTURED: 7,
  ORDER_STATUS_CAPTURE_ERROR: 8
};

/**
 * @enum {number}
 */
proto.mw.common.OrderType = {
  ORDER_TYPE_INVALID: 0,
  ORDER_TYPE_COLLECTIVE: 1,
  ORDER_TYPE_DEDICATED: 2,
  ORDER_TYPE_COLLECTIVE_STUDENT: 3
};

/**
 * @enum {number}
 */
proto.mw.common.PaymentType = {
  PAYMENT_TYPE_INVALID: 0,
  PAYMENT_TYPE_PAYPAL: 1,
  PAYMENT_TYPE_CONTRACT: 2,
  PAYMENT_TYPE_INVOICE: 3
};

/**
 * @enum {number}
 */
proto.mw.common.SpecialOfferType = {
  SPECIAL_OFFER_TYPE_INVALID: 0,
  SPECIAL_OFFER_TYPE_BANNER: 1,
  SPECIAL_OFFER_TYPE_SINGLE_CODE: 2,
  SPECIAL_OFFER_TYPE_MULTI_CODE: 3
};

/**
 * @enum {number}
 */
proto.mw.common.ImageType = {
  IMAGE_TYPE_INVALID: 0,
  IMAGE_TYPE_MENU: 1,
  IMAGE_TYPE_SHOP: 2
};

/**
 * @enum {number}
 */
proto.mw.common.UsageType = {
  USAGE_TYPE_INVALID: 0,
  USAGE_TYPE_INITIAL_VISIT: 1,
  USAGE_TYPE_SUBSEQUENT_VISIT: 2,
  USAGE_TYPE_VISIT_ERROR: 3,
  USAGE_TYPE_MINI_SHOP_CREATE_ORDER: 4,
  USAGE_TYPE_MINI_SHOP_CREATE_ORDER_VALIDATION_ERROR: 5,
  USAGE_TYPE_MINI_SHOP_CREATE_ORDER_ERROR: 6,
  USAGE_TYPE_MINI_SHOP_CAPTURE_ORDER: 7,
  USAGE_TYPE_MINI_SHOP_CAPTURE_ORDER_ERROR: 8,
  USAGE_TYPE_MINI_SHOP_CANCEL_ORDER: 9,
  USAGE_TYPE_MINI_SHOP_ERROR_ORDER: 10
};

/**
 * @enum {number}
 */
proto.mw.common.OrderFormProductStatus = {
  ORDER_FORM_PRODUCT_STATUS_INVALID: 0,
  ORDER_FORM_PRODUCT_STATUS_ENABLED: 1,
  ORDER_FORM_PRODUCT_STATUS_DISABLED: 2
};

goog.object.extend(exports, proto.mw.common);
